var ei = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, s = t.length, i; n < s; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
};
function ti(e) {
  return e;
}
function Y(e, t, r, n, s, i, o, c, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return function() {
        return t(e.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(t(e.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(t(e.apply(this, arguments))));
      };
    case 5:
      return function() {
        return s(n(r(t(e.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return i(s(n(r(t(e.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return o(i(s(n(r(t(e.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return c(o(i(s(n(r(t(e.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return u(c(o(i(s(n(r(t(e.apply(this, arguments)))))))));
      };
  }
}
function y(e, t, r, n, s, i, o, c, u) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return r(t(e));
    case 4:
      return n(r(t(e)));
    case 5:
      return s(n(r(t(e))));
    case 6:
      return i(s(n(r(t(e)))));
    case 7:
      return o(i(s(n(r(t(e))))));
    case 8:
      return c(o(i(s(n(r(t(e)))))));
    case 9:
      return u(c(o(i(s(n(r(t(e))))))));
    default: {
      for (var l = arguments[0], f = 1; f < arguments.length; f++)
        l = arguments[f](l);
      return l;
    }
  }
}
var ri = function(e, t) {
  var r = function(n) {
    return n.length >= e;
  };
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? t.apply(this, n) : function(s) {
      return t.apply(void 0, ei([s], n, !1));
    };
  };
}, ni = function(e) {
  return {
    equals: function(t, r) {
      return t === r || e(t, r);
    }
  };
}, ai = function(e) {
  return ni(function(t, r) {
    for (var n in e)
      if (!e[n].equals(t[n], r[n]))
        return !1;
    return !0;
  });
}, Xn = function(e) {
  return e._tag === "Some";
}, ea = { _tag: "None" }, ta = function(e) {
  return { _tag: "Some", value: e };
}, si = function(e) {
  return e._tag === "Left";
}, ii = function(e) {
  return e._tag === "Right";
}, oi = function(e) {
  return { _tag: "Left", left: e };
}, ci = function(e) {
  return { _tag: "Right", right: e };
}, ui = function(e) {
  return [e];
}, li = [], di = Object.prototype.hasOwnProperty, fi = function(e) {
  return function(t) {
    return function(r) {
      return r.reduce(function(n, s) {
        return e.concat(n, s);
      }, t);
    };
  };
}, pi = function(e) {
  return {
    concat: function(t, r) {
      var n = {};
      for (var s in e)
        di.call(e, s) && (n[s] = e[s].concat(t[s], r[s]));
      return n;
    }
  };
}, ir = function() {
  return { concat: ti };
}, hi = function() {
  return { concat: function(e, t) {
    return t;
  } };
}, vi = fi, nn = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, s = t.length, i; n < s; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}, mi = li, gi = function(e, t) {
  return e < 0 || e >= t.length;
}, yi = function(e) {
  return function(t) {
    return nn(nn([], t, !0), [e], !1);
  };
}, _i = yi, bi = ui, Q = {
  equals: function(e, t) {
    return e === t;
  }
}, Ti = {
  concat: function(e, t) {
    return e + t;
  }
}, $i = "", wr = {
  concat: Ti.concat,
  empty: $i
};
Q.equals;
var ra = function(e) {
  return e.trim();
}, na = function(e) {
  return e.length === 0;
}, yt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function aa(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Ai() {
  this.__data__ = [], this.size = 0;
}
var Si = Ai;
function Ei(e, t) {
  return e === t || e !== e && t !== t;
}
var xr = Ei, wi = xr;
function xi(e, t) {
  for (var r = e.length; r--; )
    if (wi(e[r][0], t))
      return r;
  return -1;
}
var Vt = xi, ki = Vt, Ri = Array.prototype, ji = Ri.splice;
function Oi(e) {
  var t = this.__data__, r = ki(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : ji.call(t, r, 1), --this.size, !0;
}
var Ci = Oi, Ii = Vt;
function Mi(e) {
  var t = this.__data__, r = Ii(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var Ni = Mi, Pi = Vt;
function Vi(e) {
  return Pi(this.__data__, e) > -1;
}
var Di = Vi, Li = Vt;
function Ui(e, t) {
  var r = this.__data__, n = Li(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var Zi = Ui, Hi = Si, qi = Ci, Bi = Ni, Gi = Di, zi = Zi;
function Ee(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ee.prototype.clear = Hi;
Ee.prototype.delete = qi;
Ee.prototype.get = Bi;
Ee.prototype.has = Gi;
Ee.prototype.set = zi;
var Dt = Ee, Fi = Dt;
function Ki() {
  this.__data__ = new Fi(), this.size = 0;
}
var Wi = Ki;
function Qi(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var Ji = Qi;
function Yi(e) {
  return this.__data__.get(e);
}
var Xi = Yi;
function eo(e) {
  return this.__data__.has(e);
}
var to = eo, ro = typeof yt == "object" && yt && yt.Object === Object && yt, sa = ro, no = sa, ao = typeof self == "object" && self && self.Object === Object && self, so = no || ao || Function("return this")(), F = so, io = F, oo = io.Symbol, Lt = oo, an = Lt, ia = Object.prototype, co = ia.hasOwnProperty, uo = ia.toString, Le = an ? an.toStringTag : void 0;
function lo(e) {
  var t = co.call(e, Le), r = e[Le];
  try {
    e[Le] = void 0;
    var n = !0;
  } catch {
  }
  var s = uo.call(e);
  return n && (t ? e[Le] = r : delete e[Le]), s;
}
var fo = lo, po = Object.prototype, ho = po.toString;
function vo(e) {
  return ho.call(e);
}
var mo = vo, sn = Lt, go = fo, yo = mo, _o = "[object Null]", bo = "[object Undefined]", on = sn ? sn.toStringTag : void 0;
function To(e) {
  return e == null ? e === void 0 ? bo : _o : on && on in Object(e) ? go(e) : yo(e);
}
var Ut = To;
function $o(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var nt = $o, Ao = Ut, So = nt, Eo = "[object AsyncFunction]", wo = "[object Function]", xo = "[object GeneratorFunction]", ko = "[object Proxy]";
function Ro(e) {
  if (!So(e))
    return !1;
  var t = Ao(e);
  return t == wo || t == xo || t == Eo || t == ko;
}
var oa = Ro, jo = F, Oo = jo["__core-js_shared__"], Co = Oo, or = Co, cn = function() {
  var e = /[^.]+$/.exec(or && or.keys && or.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Io(e) {
  return !!cn && cn in e;
}
var Mo = Io, No = Function.prototype, Po = No.toString;
function Vo(e) {
  if (e != null) {
    try {
      return Po.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var ca = Vo, Do = oa, Lo = Mo, Uo = nt, Zo = ca, Ho = /[\\^$.*+?()[\]{}|]/g, qo = /^\[object .+?Constructor\]$/, Bo = Function.prototype, Go = Object.prototype, zo = Bo.toString, Fo = Go.hasOwnProperty, Ko = RegExp(
  "^" + zo.call(Fo).replace(Ho, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Wo(e) {
  if (!Uo(e) || Lo(e))
    return !1;
  var t = Do(e) ? Ko : qo;
  return t.test(Zo(e));
}
var Qo = Wo;
function Jo(e, t) {
  return e == null ? void 0 : e[t];
}
var Yo = Jo, Xo = Qo, ec = Yo;
function tc(e, t) {
  var r = ec(e, t);
  return Xo(r) ? r : void 0;
}
var de = tc, rc = de, nc = F, ac = rc(nc, "Map"), kr = ac, sc = de, ic = sc(Object, "create"), Zt = ic, un = Zt;
function oc() {
  this.__data__ = un ? un(null) : {}, this.size = 0;
}
var cc = oc;
function uc(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var lc = uc, dc = Zt, fc = "__lodash_hash_undefined__", pc = Object.prototype, hc = pc.hasOwnProperty;
function vc(e) {
  var t = this.__data__;
  if (dc) {
    var r = t[e];
    return r === fc ? void 0 : r;
  }
  return hc.call(t, e) ? t[e] : void 0;
}
var mc = vc, gc = Zt, yc = Object.prototype, _c = yc.hasOwnProperty;
function bc(e) {
  var t = this.__data__;
  return gc ? t[e] !== void 0 : _c.call(t, e);
}
var Tc = bc, $c = Zt, Ac = "__lodash_hash_undefined__";
function Sc(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = $c && t === void 0 ? Ac : t, this;
}
var Ec = Sc, wc = cc, xc = lc, kc = mc, Rc = Tc, jc = Ec;
function we(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
we.prototype.clear = wc;
we.prototype.delete = xc;
we.prototype.get = kc;
we.prototype.has = Rc;
we.prototype.set = jc;
var Oc = we, ln = Oc, Cc = Dt, Ic = kr;
function Mc() {
  this.size = 0, this.__data__ = {
    hash: new ln(),
    map: new (Ic || Cc)(),
    string: new ln()
  };
}
var Nc = Mc;
function Pc(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Vc = Pc, Dc = Vc;
function Lc(e, t) {
  var r = e.__data__;
  return Dc(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var Ht = Lc, Uc = Ht;
function Zc(e) {
  var t = Uc(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Hc = Zc, qc = Ht;
function Bc(e) {
  return qc(this, e).get(e);
}
var Gc = Bc, zc = Ht;
function Fc(e) {
  return zc(this, e).has(e);
}
var Kc = Fc, Wc = Ht;
function Qc(e, t) {
  var r = Wc(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var Jc = Qc, Yc = Nc, Xc = Hc, eu = Gc, tu = Kc, ru = Jc;
function xe(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
xe.prototype.clear = Yc;
xe.prototype.delete = Xc;
xe.prototype.get = eu;
xe.prototype.has = tu;
xe.prototype.set = ru;
var ua = xe, nu = Dt, au = kr, su = ua, iu = 200;
function ou(e, t) {
  var r = this.__data__;
  if (r instanceof nu) {
    var n = r.__data__;
    if (!au || n.length < iu - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new su(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var cu = ou, uu = Dt, lu = Wi, du = Ji, fu = Xi, pu = to, hu = cu;
function ke(e) {
  var t = this.__data__ = new uu(e);
  this.size = t.size;
}
ke.prototype.clear = lu;
ke.prototype.delete = du;
ke.prototype.get = fu;
ke.prototype.has = pu;
ke.prototype.set = hu;
var la = ke;
function vu(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1; )
    ;
  return e;
}
var mu = vu, gu = de, yu = function() {
  try {
    var e = gu(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), _u = yu, dn = _u;
function bu(e, t, r) {
  t == "__proto__" && dn ? dn(e, t, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : e[t] = r;
}
var da = bu, Tu = da, $u = xr, Au = Object.prototype, Su = Au.hasOwnProperty;
function Eu(e, t, r) {
  var n = e[t];
  (!(Su.call(e, t) && $u(n, r)) || r === void 0 && !(t in e)) && Tu(e, t, r);
}
var fa = Eu, wu = fa, xu = da;
function ku(e, t, r, n) {
  var s = !r;
  r || (r = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var c = t[i], u = n ? n(r[c], e[c], c, r, e) : void 0;
    u === void 0 && (u = e[c]), s ? xu(r, c, u) : wu(r, c, u);
  }
  return r;
}
var qt = ku;
function Ru(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var ju = Ru;
function Ou(e) {
  return e != null && typeof e == "object";
}
var Re = Ou, Cu = Ut, Iu = Re, Mu = "[object Arguments]";
function Nu(e) {
  return Iu(e) && Cu(e) == Mu;
}
var Pu = Nu, fn = Pu, Vu = Re, pa = Object.prototype, Du = pa.hasOwnProperty, Lu = pa.propertyIsEnumerable, Uu = fn(/* @__PURE__ */ function() {
  return arguments;
}()) ? fn : function(e) {
  return Vu(e) && Du.call(e, "callee") && !Lu.call(e, "callee");
}, Zu = Uu, Hu = Array.isArray, Bt = Hu, $t = { exports: {} };
function qu() {
  return !1;
}
var Bu = qu;
$t.exports;
(function(e, t) {
  var r = F, n = Bu, s = t && !t.nodeType && t, i = s && !0 && e && !e.nodeType && e, o = i && i.exports === s, c = o ? r.Buffer : void 0, u = c ? c.isBuffer : void 0, l = u || n;
  e.exports = l;
})($t, $t.exports);
var Rr = $t.exports, Gu = 9007199254740991, zu = /^(?:0|[1-9]\d*)$/;
function Fu(e, t) {
  var r = typeof e;
  return t = t ?? Gu, !!t && (r == "number" || r != "symbol" && zu.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Ku = Fu, Wu = 9007199254740991;
function Qu(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Wu;
}
var ha = Qu, Ju = Ut, Yu = ha, Xu = Re, el = "[object Arguments]", tl = "[object Array]", rl = "[object Boolean]", nl = "[object Date]", al = "[object Error]", sl = "[object Function]", il = "[object Map]", ol = "[object Number]", cl = "[object Object]", ul = "[object RegExp]", ll = "[object Set]", dl = "[object String]", fl = "[object WeakMap]", pl = "[object ArrayBuffer]", hl = "[object DataView]", vl = "[object Float32Array]", ml = "[object Float64Array]", gl = "[object Int8Array]", yl = "[object Int16Array]", _l = "[object Int32Array]", bl = "[object Uint8Array]", Tl = "[object Uint8ClampedArray]", $l = "[object Uint16Array]", Al = "[object Uint32Array]", w = {};
w[vl] = w[ml] = w[gl] = w[yl] = w[_l] = w[bl] = w[Tl] = w[$l] = w[Al] = !0;
w[el] = w[tl] = w[pl] = w[rl] = w[hl] = w[nl] = w[al] = w[sl] = w[il] = w[ol] = w[cl] = w[ul] = w[ll] = w[dl] = w[fl] = !1;
function Sl(e) {
  return Xu(e) && Yu(e.length) && !!w[Ju(e)];
}
var El = Sl;
function wl(e) {
  return function(t) {
    return e(t);
  };
}
var jr = wl, At = { exports: {} };
At.exports;
(function(e, t) {
  var r = sa, n = t && !t.nodeType && t, s = n && !0 && e && !e.nodeType && e, i = s && s.exports === n, o = i && r.process, c = function() {
    try {
      var u = s && s.require && s.require("util").types;
      return u || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = c;
})(At, At.exports);
var Or = At.exports, xl = El, kl = jr, pn = Or, hn = pn && pn.isTypedArray, Rl = hn ? kl(hn) : xl, va = Rl, jl = ju, Ol = Zu, Cl = Bt, Il = Rr, Ml = Ku, Nl = va, Pl = Object.prototype, Vl = Pl.hasOwnProperty;
function Dl(e, t) {
  var r = Cl(e), n = !r && Ol(e), s = !r && !n && Il(e), i = !r && !n && !s && Nl(e), o = r || n || s || i, c = o ? jl(e.length, String) : [], u = c.length;
  for (var l in e)
    (t || Vl.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    Ml(l, u))) && c.push(l);
  return c;
}
var ma = Dl, Ll = Object.prototype;
function Ul(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Ll;
  return e === r;
}
var Cr = Ul;
function Zl(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var ga = Zl, Hl = ga, ql = Hl(Object.keys, Object), Bl = ql, Gl = Cr, zl = Bl, Fl = Object.prototype, Kl = Fl.hasOwnProperty;
function Wl(e) {
  if (!Gl(e))
    return zl(e);
  var t = [];
  for (var r in Object(e))
    Kl.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var Ql = Wl, Jl = oa, Yl = ha;
function Xl(e) {
  return e != null && Yl(e.length) && !Jl(e);
}
var ya = Xl, ed = ma, td = Ql, rd = ya;
function nd(e) {
  return rd(e) ? ed(e) : td(e);
}
var Ir = nd, ad = qt, sd = Ir;
function id(e, t) {
  return e && ad(t, sd(t), e);
}
var od = id;
function cd(e) {
  var t = [];
  if (e != null)
    for (var r in Object(e))
      t.push(r);
  return t;
}
var ud = cd, ld = nt, dd = Cr, fd = ud, pd = Object.prototype, hd = pd.hasOwnProperty;
function vd(e) {
  if (!ld(e))
    return fd(e);
  var t = dd(e), r = [];
  for (var n in e)
    n == "constructor" && (t || !hd.call(e, n)) || r.push(n);
  return r;
}
var md = vd, gd = ma, yd = md, _d = ya;
function bd(e) {
  return _d(e) ? gd(e, !0) : yd(e);
}
var Mr = bd, Td = qt, $d = Mr;
function Ad(e, t) {
  return e && Td(t, $d(t), e);
}
var Sd = Ad, St = { exports: {} };
St.exports;
(function(e, t) {
  var r = F, n = t && !t.nodeType && t, s = n && !0 && e && !e.nodeType && e, i = s && s.exports === n, o = i ? r.Buffer : void 0, c = o ? o.allocUnsafe : void 0;
  function u(l, f) {
    if (f)
      return l.slice();
    var _ = l.length, A = c ? c(_) : new l.constructor(_);
    return l.copy(A), A;
  }
  e.exports = u;
})(St, St.exports);
var Ed = St.exports;
function wd(e, t) {
  var r = -1, n = e.length;
  for (t || (t = Array(n)); ++r < n; )
    t[r] = e[r];
  return t;
}
var xd = wd;
function kd(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, s = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[s++] = o);
  }
  return i;
}
var Rd = kd;
function jd() {
  return [];
}
var _a = jd, Od = Rd, Cd = _a, Id = Object.prototype, Md = Id.propertyIsEnumerable, vn = Object.getOwnPropertySymbols, Nd = vn ? function(e) {
  return e == null ? [] : (e = Object(e), Od(vn(e), function(t) {
    return Md.call(e, t);
  }));
} : Cd, Nr = Nd, Pd = qt, Vd = Nr;
function Dd(e, t) {
  return Pd(e, Vd(e), t);
}
var Ld = Dd;
function Ud(e, t) {
  for (var r = -1, n = t.length, s = e.length; ++r < n; )
    e[s + r] = t[r];
  return e;
}
var ba = Ud, Zd = ga, Hd = Zd(Object.getPrototypeOf, Object), Ta = Hd, qd = ba, Bd = Ta, Gd = Nr, zd = _a, Fd = Object.getOwnPropertySymbols, Kd = Fd ? function(e) {
  for (var t = []; e; )
    qd(t, Gd(e)), e = Bd(e);
  return t;
} : zd, $a = Kd, Wd = qt, Qd = $a;
function Jd(e, t) {
  return Wd(e, Qd(e), t);
}
var Yd = Jd, Xd = ba, ef = Bt;
function tf(e, t, r) {
  var n = t(e);
  return ef(e) ? n : Xd(n, r(e));
}
var Aa = tf, rf = Aa, nf = Nr, af = Ir;
function sf(e) {
  return rf(e, af, nf);
}
var Sa = sf, of = Aa, cf = $a, uf = Mr;
function lf(e) {
  return of(e, uf, cf);
}
var df = lf, ff = de, pf = F, hf = ff(pf, "DataView"), vf = hf, mf = de, gf = F, yf = mf(gf, "Promise"), _f = yf, bf = de, Tf = F, $f = bf(Tf, "Set"), Af = $f, Sf = de, Ef = F, wf = Sf(Ef, "WeakMap"), xf = wf, pr = vf, hr = kr, vr = _f, mr = Af, gr = xf, Ea = Ut, je = ca, mn = "[object Map]", kf = "[object Object]", gn = "[object Promise]", yn = "[object Set]", _n = "[object WeakMap]", bn = "[object DataView]", Rf = je(pr), jf = je(hr), Of = je(vr), Cf = je(mr), If = je(gr), oe = Ea;
(pr && oe(new pr(new ArrayBuffer(1))) != bn || hr && oe(new hr()) != mn || vr && oe(vr.resolve()) != gn || mr && oe(new mr()) != yn || gr && oe(new gr()) != _n) && (oe = function(e) {
  var t = Ea(e), r = t == kf ? e.constructor : void 0, n = r ? je(r) : "";
  if (n)
    switch (n) {
      case Rf:
        return bn;
      case jf:
        return mn;
      case Of:
        return gn;
      case Cf:
        return yn;
      case If:
        return _n;
    }
  return t;
});
var Gt = oe, Mf = Object.prototype, Nf = Mf.hasOwnProperty;
function Pf(e) {
  var t = e.length, r = new e.constructor(t);
  return t && typeof e[0] == "string" && Nf.call(e, "index") && (r.index = e.index, r.input = e.input), r;
}
var Vf = Pf, Df = F, Lf = Df.Uint8Array, wa = Lf, Tn = wa;
function Uf(e) {
  var t = new e.constructor(e.byteLength);
  return new Tn(t).set(new Tn(e)), t;
}
var Pr = Uf, Zf = Pr;
function Hf(e, t) {
  var r = t ? Zf(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
var qf = Hf, Bf = /\w*$/;
function Gf(e) {
  var t = new e.constructor(e.source, Bf.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var zf = Gf, $n = Lt, An = $n ? $n.prototype : void 0, Sn = An ? An.valueOf : void 0;
function Ff(e) {
  return Sn ? Object(Sn.call(e)) : {};
}
var Kf = Ff, Wf = Pr;
function Qf(e, t) {
  var r = t ? Wf(e.buffer) : e.buffer;
  return new e.constructor(r, e.byteOffset, e.length);
}
var Jf = Qf, Yf = Pr, Xf = qf, ep = zf, tp = Kf, rp = Jf, np = "[object Boolean]", ap = "[object Date]", sp = "[object Map]", ip = "[object Number]", op = "[object RegExp]", cp = "[object Set]", up = "[object String]", lp = "[object Symbol]", dp = "[object ArrayBuffer]", fp = "[object DataView]", pp = "[object Float32Array]", hp = "[object Float64Array]", vp = "[object Int8Array]", mp = "[object Int16Array]", gp = "[object Int32Array]", yp = "[object Uint8Array]", _p = "[object Uint8ClampedArray]", bp = "[object Uint16Array]", Tp = "[object Uint32Array]";
function $p(e, t, r) {
  var n = e.constructor;
  switch (t) {
    case dp:
      return Yf(e);
    case np:
    case ap:
      return new n(+e);
    case fp:
      return Xf(e, r);
    case pp:
    case hp:
    case vp:
    case mp:
    case gp:
    case yp:
    case _p:
    case bp:
    case Tp:
      return rp(e, r);
    case sp:
      return new n();
    case ip:
    case up:
      return new n(e);
    case op:
      return ep(e);
    case cp:
      return new n();
    case lp:
      return tp(e);
  }
}
var Ap = $p, Sp = nt, En = Object.create, Ep = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Sp(t))
      return {};
    if (En)
      return En(t);
    e.prototype = t;
    var r = new e();
    return e.prototype = void 0, r;
  };
}(), wp = Ep, xp = wp, kp = Ta, Rp = Cr;
function jp(e) {
  return typeof e.constructor == "function" && !Rp(e) ? xp(kp(e)) : {};
}
var Op = jp, Cp = Gt, Ip = Re, Mp = "[object Map]";
function Np(e) {
  return Ip(e) && Cp(e) == Mp;
}
var Pp = Np, Vp = Pp, Dp = jr, wn = Or, xn = wn && wn.isMap, Lp = xn ? Dp(xn) : Vp, Up = Lp, Zp = Gt, Hp = Re, qp = "[object Set]";
function Bp(e) {
  return Hp(e) && Zp(e) == qp;
}
var Gp = Bp, zp = Gp, Fp = jr, kn = Or, Rn = kn && kn.isSet, Kp = Rn ? Fp(Rn) : zp, Wp = Kp, Qp = la, Jp = mu, Yp = fa, Xp = od, eh = Sd, th = Ed, rh = xd, nh = Ld, ah = Yd, sh = Sa, ih = df, oh = Gt, ch = Vf, uh = Ap, lh = Op, dh = Bt, fh = Rr, ph = Up, hh = nt, vh = Wp, mh = Ir, gh = Mr, yh = 1, _h = 2, bh = 4, xa = "[object Arguments]", Th = "[object Array]", $h = "[object Boolean]", Ah = "[object Date]", Sh = "[object Error]", ka = "[object Function]", Eh = "[object GeneratorFunction]", wh = "[object Map]", xh = "[object Number]", Ra = "[object Object]", kh = "[object RegExp]", Rh = "[object Set]", jh = "[object String]", Oh = "[object Symbol]", Ch = "[object WeakMap]", Ih = "[object ArrayBuffer]", Mh = "[object DataView]", Nh = "[object Float32Array]", Ph = "[object Float64Array]", Vh = "[object Int8Array]", Dh = "[object Int16Array]", Lh = "[object Int32Array]", Uh = "[object Uint8Array]", Zh = "[object Uint8ClampedArray]", Hh = "[object Uint16Array]", qh = "[object Uint32Array]", S = {};
S[xa] = S[Th] = S[Ih] = S[Mh] = S[$h] = S[Ah] = S[Nh] = S[Ph] = S[Vh] = S[Dh] = S[Lh] = S[wh] = S[xh] = S[Ra] = S[kh] = S[Rh] = S[jh] = S[Oh] = S[Uh] = S[Zh] = S[Hh] = S[qh] = !0;
S[Sh] = S[ka] = S[Ch] = !1;
function Tt(e, t, r, n, s, i) {
  var o, c = t & yh, u = t & _h, l = t & bh;
  if (r && (o = s ? r(e, n, s, i) : r(e)), o !== void 0)
    return o;
  if (!hh(e))
    return e;
  var f = dh(e);
  if (f) {
    if (o = ch(e), !c)
      return rh(e, o);
  } else {
    var _ = oh(e), A = _ == ka || _ == Eh;
    if (fh(e))
      return th(e, c);
    if (_ == Ra || _ == xa || A && !s) {
      if (o = u || A ? {} : lh(e), !c)
        return u ? ah(e, eh(o, e)) : nh(e, Xp(o, e));
    } else {
      if (!S[_])
        return s ? e : {};
      o = uh(e, _, c);
    }
  }
  i || (i = new Qp());
  var I = i.get(e);
  if (I)
    return I;
  i.set(e, o), vh(e) ? e.forEach(function(O) {
    o.add(Tt(O, t, r, O, e, i));
  }) : ph(e) && e.forEach(function(O, N) {
    o.set(N, Tt(O, t, r, N, e, i));
  });
  var V = l ? u ? ih : sh : u ? gh : mh, D = f ? void 0 : V(e);
  return Jp(D || e, function(O, N) {
    D && (N = O, O = e[N]), Yp(o, N, Tt(O, t, r, N, e, i));
  }), o;
}
var Bh = Tt, Gh = Bh, zh = 1, Fh = 4;
function Kh(e) {
  return Gh(e, zh | Fh);
}
var Wh = Kh;
const Qh = /* @__PURE__ */ aa(Wh);
var $;
(function(e) {
  e.assertEqual = (s) => s;
  function t(s) {
  }
  e.assertIs = t;
  function r(s) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (s) => {
    const i = {};
    for (const o of s)
      i[o] = o;
    return i;
  }, e.getValidEnumValues = (s) => {
    const i = e.objectKeys(s).filter((c) => typeof s[s[c]] != "number"), o = {};
    for (const c of i)
      o[c] = s[c];
    return e.objectValues(o);
  }, e.objectValues = (s) => e.objectKeys(s).map(function(i) {
    return s[i];
  }), e.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const i = [];
    for (const o in s)
      Object.prototype.hasOwnProperty.call(s, o) && i.push(o);
    return i;
  }, e.find = (s, i) => {
    for (const o of s)
      if (i(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function n(s, i = " | ") {
    return s.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (s, i) => typeof i == "bigint" ? i.toString() : i;
})($ || ($ = {}));
var yr;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(yr || (yr = {}));
const h = $.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), J = (e) => {
  switch (typeof e) {
    case "undefined":
      return h.undefined;
    case "string":
      return h.string;
    case "number":
      return isNaN(e) ? h.nan : h.number;
    case "boolean":
      return h.boolean;
    case "function":
      return h.function;
    case "bigint":
      return h.bigint;
    case "symbol":
      return h.symbol;
    case "object":
      return Array.isArray(e) ? h.array : e === null ? h.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? h.promise : typeof Map < "u" && e instanceof Map ? h.map : typeof Set < "u" && e instanceof Set ? h.set : typeof Date < "u" && e instanceof Date ? h.date : h.object;
    default:
      return h.unknown;
  }
}, d = $.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Jh = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class L extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const r = t || function(i) {
      return i.message;
    }, n = { _errors: [] }, s = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(s);
        else if (o.code === "invalid_return_type")
          s(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          s(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let c = n, u = 0;
          for (; u < o.path.length; ) {
            const l = o.path[u];
            u === o.path.length - 1 ? (c[l] = c[l] || { _errors: [] }, c[l]._errors.push(r(o))) : c[l] = c[l] || { _errors: [] }, c = c[l], u++;
          }
        }
    };
    return s(this), n;
  }
  static assert(t) {
    if (!(t instanceof L))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, $.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (r[s.path[0]] = r[s.path[0]] || [], r[s.path[0]].push(t(s))) : n.push(t(s));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
L.create = (e) => new L(e);
const ye = (e, t) => {
  let r;
  switch (e.code) {
    case d.invalid_type:
      e.received === h.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case d.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, $.jsonStringifyReplacer)}`;
      break;
    case d.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${$.joinValues(e.keys, ", ")}`;
      break;
    case d.invalid_union:
      r = "Invalid input";
      break;
    case d.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${$.joinValues(e.options)}`;
      break;
    case d.invalid_enum_value:
      r = `Invalid enum value. Expected ${$.joinValues(e.options)}, received '${e.received}'`;
      break;
    case d.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case d.invalid_return_type:
      r = "Invalid function return type";
      break;
    case d.invalid_date:
      r = "Invalid date";
      break;
    case d.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : $.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case d.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case d.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case d.custom:
      r = "Invalid input";
      break;
    case d.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case d.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case d.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, $.assertNever(e);
  }
  return { message: r };
};
let ja = ye;
function Yh(e) {
  ja = e;
}
function Et() {
  return ja;
}
const wt = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: s } = e, i = [...r, ...s.path || []], o = {
    ...s,
    path: i
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: i,
      message: s.message
    };
  let c = "";
  const u = n.filter((l) => !!l).slice().reverse();
  for (const l of u)
    c = l(o, { data: t, defaultError: c }).message;
  return {
    ...s,
    path: i,
    message: c
  };
}, Xh = [];
function p(e, t) {
  const r = Et(), n = wt({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      r,
      r === ye ? void 0 : ye
      // then global default map
    ].filter((s) => !!s)
  });
  e.common.issues.push(n);
}
class M {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const s of r) {
      if (s.status === "aborted")
        return g;
      s.status === "dirty" && t.dirty(), n.push(s.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const s of r) {
      const i = await s.key, o = await s.value;
      n.push({
        key: i,
        value: o
      });
    }
    return M.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const s of r) {
      const { key: i, value: o } = s;
      if (i.status === "aborted" || o.status === "aborted")
        return g;
      i.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || s.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: t.value, value: n };
  }
}
const g = Object.freeze({
  status: "aborted"
}), me = (e) => ({ status: "dirty", value: e }), P = (e) => ({ status: "valid", value: e }), _r = (e) => e.status === "aborted", br = (e) => e.status === "dirty", He = (e) => e.status === "valid", qe = (e) => typeof Promise < "u" && e instanceof Promise;
function xt(e, t, r, n) {
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function Oa(e, t, r, n, s) {
  if (typeof t == "function" ? e !== t || !s : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, r), r;
}
var v;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(v || (v = {}));
var Ue, Ze;
class B {
  constructor(t, r, n, s) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const jn = (e, t) => {
  if (He(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new L(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function b(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: s } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: s } : { errorMap: (o, c) => {
    var u, l;
    const { message: f } = e;
    return o.code === "invalid_enum_value" ? { message: f ?? c.defaultError } : typeof c.data > "u" ? { message: (u = f ?? n) !== null && u !== void 0 ? u : c.defaultError } : o.code !== "invalid_type" ? { message: c.defaultError } : { message: (l = f ?? r) !== null && l !== void 0 ? l : c.defaultError };
  }, description: s };
}
class T {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return J(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: J(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new M(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: J(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (qe(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    var n;
    const s = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: J(t)
    }, i = this._parseSync({ data: t, path: s.path, parent: s });
    return jn(s, i);
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: J(t)
    }, s = this._parse({ data: t, path: n.path, parent: n }), i = await (qe(s) ? s : Promise.resolve(s));
    return jn(n, i);
  }
  refine(t, r) {
    const n = (s) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(s) : r;
    return this._refinement((s, i) => {
      const o = t(s), c = () => i.addIssue({
        code: d.custom,
        ...n(s)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((u) => u ? !0 : (c(), !1)) : o ? !0 : (c(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, s) => t(n) ? !0 : (s.addIssue(typeof r == "function" ? r(n, s) : r), !1));
  }
  _refinement(t) {
    return new H({
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return q.create(this, this._def);
  }
  nullable() {
    return re.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Z.create(this, this._def);
  }
  promise() {
    return be.create(this, this._def);
  }
  or(t) {
    return Fe.create([this, t], this._def);
  }
  and(t) {
    return Ke.create(this, t, this._def);
  }
  transform(t) {
    return new H({
      ...b(this._def),
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new Xe({
      ...b(this._def),
      innerType: this,
      defaultValue: r,
      typeName: m.ZodDefault
    });
  }
  brand() {
    return new Vr({
      typeName: m.ZodBranded,
      type: this,
      ...b(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new et({
      ...b(this._def),
      innerType: this,
      catchValue: r,
      typeName: m.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return at.create(this, t);
  }
  readonly() {
    return tt.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const ev = /^c[^\s-]{8,}$/i, tv = /^[0-9a-z]+$/, rv = /^[0-9A-HJKMNP-TV-Z]{26}$/, nv = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, av = /^[a-z0-9_-]{21}$/i, sv = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, iv = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, ov = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let cr;
const cv = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, uv = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, lv = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Ca = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", dv = new RegExp(`^${Ca}$`);
function Ia(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function fv(e) {
  return new RegExp(`^${Ia(e)}$`);
}
function Ma(e) {
  let t = `${Ca}T${Ia(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function pv(e, t) {
  return !!((t === "v4" || !t) && cv.test(e) || (t === "v6" || !t) && uv.test(e));
}
class U extends T {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== h.string) {
      const i = this._getOrReturnCtx(t);
      return p(i, {
        code: d.invalid_type,
        expected: h.string,
        received: i.parsedType
      }), g;
    }
    const n = new M();
    let s;
    for (const i of this._def.checks)
      if (i.kind === "min")
        t.data.length < i.value && (s = this._getOrReturnCtx(t, s), p(s, {
          code: d.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        t.data.length > i.value && (s = this._getOrReturnCtx(t, s), p(s, {
          code: d.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = t.data.length > i.value, c = t.data.length < i.value;
        (o || c) && (s = this._getOrReturnCtx(t, s), o ? p(s, {
          code: d.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : c && p(s, {
          code: d.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        iv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "email",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        cr || (cr = new RegExp(ov, "u")), cr.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "emoji",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        nv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "uuid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        av.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "nanoid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        ev.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "cuid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        tv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "cuid2",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        rv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
          validation: "ulid",
          code: d.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(t.data);
        } catch {
          s = this._getOrReturnCtx(t, s), p(s, {
            validation: "url",
            code: d.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        validation: "regex",
        code: d.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? t.data = t.data.trim() : i.kind === "includes" ? t.data.includes(i.value, i.position) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : i.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : i.kind === "startsWith" ? t.data.startsWith(i.value) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? t.data.endsWith(i.value) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? Ma(i).test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? dv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? fv(i).test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? sv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        validation: "duration",
        code: d.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? pv(t.data, i.version) || (s = this._getOrReturnCtx(t, s), p(s, {
        validation: "ip",
        code: d.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? lv.test(t.data) || (s = this._getOrReturnCtx(t, s), p(s, {
        validation: "base64",
        code: d.invalid_string,
        message: i.message
      }), n.dirty()) : $.assertNever(i);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((s) => t.test(s), {
      validation: r,
      code: d.invalid_string,
      ...v.errToObj(n)
    });
  }
  _addCheck(t) {
    return new U({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...v.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...v.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...v.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...v.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...v.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...v.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...v.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...v.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...v.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...v.errToObj(t) });
  }
  datetime(t) {
    var r, n;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (r = t == null ? void 0 : t.offset) !== null && r !== void 0 ? r : !1,
      local: (n = t == null ? void 0 : t.local) !== null && n !== void 0 ? n : !1,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...v.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...v.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...v.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...v.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...v.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...v.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...v.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...v.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, v.errToObj(t));
  }
  trim() {
    return new U({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new U({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new U({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
U.create = (e) => {
  var t;
  return new U({
    checks: [],
    typeName: m.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...b(e)
  });
};
function hv(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, s = r > n ? r : n, i = parseInt(e.toFixed(s).replace(".", "")), o = parseInt(t.toFixed(s).replace(".", ""));
  return i % o / Math.pow(10, s);
}
class X extends T {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== h.number) {
      const i = this._getOrReturnCtx(t);
      return p(i, {
        code: d.invalid_type,
        expected: h.number,
        received: i.parsedType
      }), g;
    }
    let n;
    const s = new M();
    for (const i of this._def.checks)
      i.kind === "int" ? $.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), s.dirty()) : i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? hv(t.data, i.value) !== 0 && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : i.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.not_finite,
        message: i.message
      }), s.dirty()) : $.assertNever(i);
    return { status: s.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, s) {
    return new X({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(s)
        }
      ]
    });
  }
  _addCheck(t) {
    return new X({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: v.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: v.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: v.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: v.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && $.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
X.create = (e) => new X({
  checks: [],
  typeName: m.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...b(e)
});
class ee extends T {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== h.bigint) {
      const i = this._getOrReturnCtx(t);
      return p(i, {
        code: d.invalid_type,
        expected: h.bigint,
        received: i.parsedType
      }), g;
    }
    let n;
    const s = new M();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? t.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), p(n, {
        code: d.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : $.assertNever(i);
    return { status: s.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, v.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, v.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, v.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, v.toString(r));
  }
  setLimit(t, r, n, s) {
    return new ee({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: v.toString(s)
        }
      ]
    });
  }
  _addCheck(t) {
    return new ee({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: v.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: v.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: v.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
ee.create = (e) => {
  var t;
  return new ee({
    checks: [],
    typeName: m.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...b(e)
  });
};
class Be extends T {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== h.boolean) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.boolean,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
Be.create = (e) => new Be({
  typeName: m.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...b(e)
});
class ue extends T {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== h.date) {
      const i = this._getOrReturnCtx(t);
      return p(i, {
        code: d.invalid_type,
        expected: h.date,
        received: i.parsedType
      }), g;
    }
    if (isNaN(t.data.getTime())) {
      const i = this._getOrReturnCtx(t);
      return p(i, {
        code: d.invalid_date
      }), g;
    }
    const n = new M();
    let s;
    for (const i of this._def.checks)
      i.kind === "min" ? t.data.getTime() < i.value && (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? t.data.getTime() > i.value && (s = this._getOrReturnCtx(t, s), p(s, {
        code: d.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : $.assertNever(i);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new ue({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: v.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
ue.create = (e) => new ue({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: m.ZodDate,
  ...b(e)
});
class kt extends T {
  _parse(t) {
    if (this._getType(t) !== h.symbol) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.symbol,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
kt.create = (e) => new kt({
  typeName: m.ZodSymbol,
  ...b(e)
});
class Ge extends T {
  _parse(t) {
    if (this._getType(t) !== h.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.undefined,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
Ge.create = (e) => new Ge({
  typeName: m.ZodUndefined,
  ...b(e)
});
class ze extends T {
  _parse(t) {
    if (this._getType(t) !== h.null) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.null,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
ze.create = (e) => new ze({
  typeName: m.ZodNull,
  ...b(e)
});
class _e extends T {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return P(t.data);
  }
}
_e.create = (e) => new _e({
  typeName: m.ZodAny,
  ...b(e)
});
class ce extends T {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return P(t.data);
  }
}
ce.create = (e) => new ce({
  typeName: m.ZodUnknown,
  ...b(e)
});
class W extends T {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return p(r, {
      code: d.invalid_type,
      expected: h.never,
      received: r.parsedType
    }), g;
  }
}
W.create = (e) => new W({
  typeName: m.ZodNever,
  ...b(e)
});
class Rt extends T {
  _parse(t) {
    if (this._getType(t) !== h.undefined) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.void,
        received: n.parsedType
      }), g;
    }
    return P(t.data);
  }
}
Rt.create = (e) => new Rt({
  typeName: m.ZodVoid,
  ...b(e)
});
class Z extends T {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), s = this._def;
    if (r.parsedType !== h.array)
      return p(r, {
        code: d.invalid_type,
        expected: h.array,
        received: r.parsedType
      }), g;
    if (s.exactLength !== null) {
      const o = r.data.length > s.exactLength.value, c = r.data.length < s.exactLength.value;
      (o || c) && (p(r, {
        code: o ? d.too_big : d.too_small,
        minimum: c ? s.exactLength.value : void 0,
        maximum: o ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && r.data.length < s.minLength.value && (p(r, {
      code: d.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && r.data.length > s.maxLength.value && (p(r, {
      code: d.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, c) => s.type._parseAsync(new B(r, o, r.path, c)))).then((o) => M.mergeArray(n, o));
    const i = [...r.data].map((o, c) => s.type._parseSync(new B(r, o, r.path, c)));
    return M.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new Z({
      ...this._def,
      minLength: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new Z({
      ...this._def,
      maxLength: { value: t, message: v.toString(r) }
    });
  }
  length(t, r) {
    return new Z({
      ...this._def,
      exactLength: { value: t, message: v.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Z.create = (e, t) => new Z({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: m.ZodArray,
  ...b(t)
});
function ve(e) {
  if (e instanceof x) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = q.create(ve(n));
    }
    return new x({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof Z ? new Z({
    ...e._def,
    type: ve(e.element)
  }) : e instanceof q ? q.create(ve(e.unwrap())) : e instanceof re ? re.create(ve(e.unwrap())) : e instanceof G ? G.create(e.items.map((t) => ve(t))) : e;
}
class x extends T {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = $.objectKeys(t);
    return this._cached = { shape: t, keys: r };
  }
  _parse(t) {
    if (this._getType(t) !== h.object) {
      const l = this._getOrReturnCtx(t);
      return p(l, {
        code: d.invalid_type,
        expected: h.object,
        received: l.parsedType
      }), g;
    }
    const { status: n, ctx: s } = this._processInputParams(t), { shape: i, keys: o } = this._getCached(), c = [];
    if (!(this._def.catchall instanceof W && this._def.unknownKeys === "strip"))
      for (const l in s.data)
        o.includes(l) || c.push(l);
    const u = [];
    for (const l of o) {
      const f = i[l], _ = s.data[l];
      u.push({
        key: { status: "valid", value: l },
        value: f._parse(new B(s, _, s.path, l)),
        alwaysSet: l in s.data
      });
    }
    if (this._def.catchall instanceof W) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const f of c)
          u.push({
            key: { status: "valid", value: f },
            value: { status: "valid", value: s.data[f] }
          });
      else if (l === "strict")
        c.length > 0 && (p(s, {
          code: d.unrecognized_keys,
          keys: c
        }), n.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const f of c) {
        const _ = s.data[f];
        u.push({
          key: { status: "valid", value: f },
          value: l._parse(
            new B(s, _, s.path, f)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: f in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const f of u) {
        const _ = await f.key, A = await f.value;
        l.push({
          key: _,
          value: A,
          alwaysSet: f.alwaysSet
        });
      }
      return l;
    }).then((l) => M.mergeObjectSync(n, l)) : M.mergeObjectSync(n, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return v.errToObj, new x({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var s, i, o, c;
          const u = (o = (i = (s = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(s, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (c = v.errToObj(t).message) !== null && c !== void 0 ? c : u
          } : {
            message: u
          };
        }
      } : {}
    });
  }
  strip() {
    return new x({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new x({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new x({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new x({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: m.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new x({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    return $.objectKeys(t).forEach((n) => {
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    return $.objectKeys(this.shape).forEach((n) => {
      t[n] || (r[n] = this.shape[n]);
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ve(this);
  }
  partial(t) {
    const r = {};
    return $.objectKeys(this.shape).forEach((n) => {
      const s = this.shape[n];
      t && !t[n] ? r[n] = s : r[n] = s.optional();
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    return $.objectKeys(this.shape).forEach((n) => {
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof q; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new x({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Na($.objectKeys(this.shape));
  }
}
x.create = (e, t) => new x({
  shape: () => e,
  unknownKeys: "strip",
  catchall: W.create(),
  typeName: m.ZodObject,
  ...b(t)
});
x.strictCreate = (e, t) => new x({
  shape: () => e,
  unknownKeys: "strict",
  catchall: W.create(),
  typeName: m.ZodObject,
  ...b(t)
});
x.lazycreate = (e, t) => new x({
  shape: e,
  unknownKeys: "strip",
  catchall: W.create(),
  typeName: m.ZodObject,
  ...b(t)
});
class Fe extends T {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function s(i) {
      for (const c of i)
        if (c.result.status === "valid")
          return c.result;
      for (const c of i)
        if (c.result.status === "dirty")
          return r.common.issues.push(...c.ctx.common.issues), c.result;
      const o = i.map((c) => new L(c.ctx.common.issues));
      return p(r, {
        code: d.invalid_union,
        unionErrors: o
      }), g;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(s);
    {
      let i;
      const o = [];
      for (const u of n) {
        const l = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, f = u._parseSync({
          data: r.data,
          path: r.path,
          parent: l
        });
        if (f.status === "valid")
          return f;
        f.status === "dirty" && !i && (i = { result: f, ctx: l }), l.common.issues.length && o.push(l.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const c = o.map((u) => new L(u));
      return p(r, {
        code: d.invalid_union,
        unionErrors: c
      }), g;
    }
  }
  get options() {
    return this._def.options;
  }
}
Fe.create = (e, t) => new Fe({
  options: e,
  typeName: m.ZodUnion,
  ...b(t)
});
const K = (e) => e instanceof Qe ? K(e.schema) : e instanceof H ? K(e.innerType()) : e instanceof Je ? [e.value] : e instanceof te ? e.options : e instanceof Ye ? $.objectValues(e.enum) : e instanceof Xe ? K(e._def.innerType) : e instanceof Ge ? [void 0] : e instanceof ze ? [null] : e instanceof q ? [void 0, ...K(e.unwrap())] : e instanceof re ? [null, ...K(e.unwrap())] : e instanceof Vr || e instanceof tt ? K(e.unwrap()) : e instanceof et ? K(e._def.innerType) : [];
class zt extends T {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== h.object)
      return p(r, {
        code: d.invalid_type,
        expected: h.object,
        received: r.parsedType
      }), g;
    const n = this.discriminator, s = r.data[n], i = this.optionsMap.get(s);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (p(r, {
      code: d.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), g);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const s = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = K(i.shape[t]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const c of o) {
        if (s.has(c))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(c)}`);
        s.set(c, i);
      }
    }
    return new zt({
      typeName: m.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: s,
      ...b(n)
    });
  }
}
function Tr(e, t) {
  const r = J(e), n = J(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === h.object && n === h.object) {
    const s = $.objectKeys(t), i = $.objectKeys(e).filter((c) => s.indexOf(c) !== -1), o = { ...e, ...t };
    for (const c of i) {
      const u = Tr(e[c], t[c]);
      if (!u.valid)
        return { valid: !1 };
      o[c] = u.data;
    }
    return { valid: !0, data: o };
  } else if (r === h.array && n === h.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const s = [];
    for (let i = 0; i < e.length; i++) {
      const o = e[i], c = t[i], u = Tr(o, c);
      if (!u.valid)
        return { valid: !1 };
      s.push(u.data);
    }
    return { valid: !0, data: s };
  } else return r === h.date && n === h.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Ke extends T {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), s = (i, o) => {
      if (_r(i) || _r(o))
        return g;
      const c = Tr(i.value, o.value);
      return c.valid ? ((br(i) || br(o)) && r.dirty(), { status: r.value, value: c.data }) : (p(n, {
        code: d.invalid_intersection_types
      }), g);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => s(i, o)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Ke.create = (e, t, r) => new Ke({
  left: e,
  right: t,
  typeName: m.ZodIntersection,
  ...b(r)
});
class G extends T {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== h.array)
      return p(n, {
        code: d.invalid_type,
        expected: h.array,
        received: n.parsedType
      }), g;
    if (n.data.length < this._def.items.length)
      return p(n, {
        code: d.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), g;
    !this._def.rest && n.data.length > this._def.items.length && (p(n, {
      code: d.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, c) => {
      const u = this._def.items[c] || this._def.rest;
      return u ? u._parse(new B(n, o, n.path, c)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => M.mergeArray(r, o)) : M.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new G({
      ...this._def,
      rest: t
    });
  }
}
G.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new G({
    items: e,
    typeName: m.ZodTuple,
    rest: null,
    ...b(t)
  });
};
class We extends T {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== h.object)
      return p(n, {
        code: d.invalid_type,
        expected: h.object,
        received: n.parsedType
      }), g;
    const s = [], i = this._def.keyType, o = this._def.valueType;
    for (const c in n.data)
      s.push({
        key: i._parse(new B(n, c, n.path, c)),
        value: o._parse(new B(n, n.data[c], n.path, c)),
        alwaysSet: c in n.data
      });
    return n.common.async ? M.mergeObjectAsync(r, s) : M.mergeObjectSync(r, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof T ? new We({
      keyType: t,
      valueType: r,
      typeName: m.ZodRecord,
      ...b(n)
    }) : new We({
      keyType: U.create(),
      valueType: t,
      typeName: m.ZodRecord,
      ...b(r)
    });
  }
}
class jt extends T {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== h.map)
      return p(n, {
        code: d.invalid_type,
        expected: h.map,
        received: n.parsedType
      }), g;
    const s = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([c, u], l) => ({
      key: s._parse(new B(n, c, n.path, [l, "key"])),
      value: i._parse(new B(n, u, n.path, [l, "value"]))
    }));
    if (n.common.async) {
      const c = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of o) {
          const l = await u.key, f = await u.value;
          if (l.status === "aborted" || f.status === "aborted")
            return g;
          (l.status === "dirty" || f.status === "dirty") && r.dirty(), c.set(l.value, f.value);
        }
        return { status: r.value, value: c };
      });
    } else {
      const c = /* @__PURE__ */ new Map();
      for (const u of o) {
        const l = u.key, f = u.value;
        if (l.status === "aborted" || f.status === "aborted")
          return g;
        (l.status === "dirty" || f.status === "dirty") && r.dirty(), c.set(l.value, f.value);
      }
      return { status: r.value, value: c };
    }
  }
}
jt.create = (e, t, r) => new jt({
  valueType: t,
  keyType: e,
  typeName: m.ZodMap,
  ...b(r)
});
class le extends T {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== h.set)
      return p(n, {
        code: d.invalid_type,
        expected: h.set,
        received: n.parsedType
      }), g;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (p(n, {
      code: d.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), r.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (p(n, {
      code: d.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(u) {
      const l = /* @__PURE__ */ new Set();
      for (const f of u) {
        if (f.status === "aborted")
          return g;
        f.status === "dirty" && r.dirty(), l.add(f.value);
      }
      return { status: r.value, value: l };
    }
    const c = [...n.data.values()].map((u, l) => i._parse(new B(n, u, n.path, l)));
    return n.common.async ? Promise.all(c).then((u) => o(u)) : o(c);
  }
  min(t, r) {
    return new le({
      ...this._def,
      minSize: { value: t, message: v.toString(r) }
    });
  }
  max(t, r) {
    return new le({
      ...this._def,
      maxSize: { value: t, message: v.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
le.create = (e, t) => new le({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: m.ZodSet,
  ...b(t)
});
class ge extends T {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== h.function)
      return p(r, {
        code: d.invalid_type,
        expected: h.function,
        received: r.parsedType
      }), g;
    function n(c, u) {
      return wt({
        data: c,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          Et(),
          ye
        ].filter((l) => !!l),
        issueData: {
          code: d.invalid_arguments,
          argumentsError: u
        }
      });
    }
    function s(c, u) {
      return wt({
        data: c,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          Et(),
          ye
        ].filter((l) => !!l),
        issueData: {
          code: d.invalid_return_type,
          returnTypeError: u
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof be) {
      const c = this;
      return P(async function(...u) {
        const l = new L([]), f = await c._def.args.parseAsync(u, i).catch((I) => {
          throw l.addIssue(n(u, I)), l;
        }), _ = await Reflect.apply(o, this, f);
        return await c._def.returns._def.type.parseAsync(_, i).catch((I) => {
          throw l.addIssue(s(_, I)), l;
        });
      });
    } else {
      const c = this;
      return P(function(...u) {
        const l = c._def.args.safeParse(u, i);
        if (!l.success)
          throw new L([n(u, l.error)]);
        const f = Reflect.apply(o, this, l.data), _ = c._def.returns.safeParse(f, i);
        if (!_.success)
          throw new L([s(f, _.error)]);
        return _.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new ge({
      ...this._def,
      args: G.create(t).rest(ce.create())
    });
  }
  returns(t) {
    return new ge({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, r, n) {
    return new ge({
      args: t || G.create([]).rest(ce.create()),
      returns: r || ce.create(),
      typeName: m.ZodFunction,
      ...b(n)
    });
  }
}
class Qe extends T {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Qe.create = (e, t) => new Qe({
  getter: e,
  typeName: m.ZodLazy,
  ...b(t)
});
class Je extends T {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return p(r, {
        received: r.data,
        code: d.invalid_literal,
        expected: this._def.value
      }), g;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Je.create = (e, t) => new Je({
  value: e,
  typeName: m.ZodLiteral,
  ...b(t)
});
function Na(e, t) {
  return new te({
    values: e,
    typeName: m.ZodEnum,
    ...b(t)
  });
}
class te extends T {
  constructor() {
    super(...arguments), Ue.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        expected: $.joinValues(n),
        received: r.parsedType,
        code: d.invalid_type
      }), g;
    }
    if (xt(this, Ue) || Oa(this, Ue, new Set(this._def.values)), !xt(this, Ue).has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return p(r, {
        received: r.data,
        code: d.invalid_enum_value,
        options: n
      }), g;
    }
    return P(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return te.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return te.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
Ue = /* @__PURE__ */ new WeakMap();
te.create = Na;
class Ye extends T {
  constructor() {
    super(...arguments), Ze.set(this, void 0);
  }
  _parse(t) {
    const r = $.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== h.string && n.parsedType !== h.number) {
      const s = $.objectValues(r);
      return p(n, {
        expected: $.joinValues(s),
        received: n.parsedType,
        code: d.invalid_type
      }), g;
    }
    if (xt(this, Ze) || Oa(this, Ze, new Set($.getValidEnumValues(this._def.values))), !xt(this, Ze).has(t.data)) {
      const s = $.objectValues(r);
      return p(n, {
        received: n.data,
        code: d.invalid_enum_value,
        options: s
      }), g;
    }
    return P(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ze = /* @__PURE__ */ new WeakMap();
Ye.create = (e, t) => new Ye({
  values: e,
  typeName: m.ZodNativeEnum,
  ...b(t)
});
class be extends T {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== h.promise && r.common.async === !1)
      return p(r, {
        code: d.invalid_type,
        expected: h.promise,
        received: r.parsedType
      }), g;
    const n = r.parsedType === h.promise ? r.data : Promise.resolve(r.data);
    return P(n.then((s) => this._def.type.parseAsync(s, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
be.create = (e, t) => new be({
  type: e,
  typeName: m.ZodPromise,
  ...b(t)
});
class H extends T {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === m.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), s = this._def.effect || null, i = {
      addIssue: (o) => {
        p(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const o = s.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (c) => {
          if (r.value === "aborted")
            return g;
          const u = await this._def.schema._parseAsync({
            data: c,
            path: n.path,
            parent: n
          });
          return u.status === "aborted" ? g : u.status === "dirty" || r.value === "dirty" ? me(u.value) : u;
        });
      {
        if (r.value === "aborted")
          return g;
        const c = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return c.status === "aborted" ? g : c.status === "dirty" || r.value === "dirty" ? me(c.value) : c;
      }
    }
    if (s.type === "refinement") {
      const o = (c) => {
        const u = s.refinement(c, i);
        if (n.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return c;
      };
      if (n.common.async === !1) {
        const c = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return c.status === "aborted" ? g : (c.status === "dirty" && r.dirty(), o(c.value), { status: r.value, value: c.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((c) => c.status === "aborted" ? g : (c.status === "dirty" && r.dirty(), o(c.value).then(() => ({ status: r.value, value: c.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!He(o))
          return o;
        const c = s.transform(o.value, i);
        if (c instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: c };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => He(o) ? Promise.resolve(s.transform(o.value, i)).then((c) => ({ status: r.value, value: c })) : o);
    $.assertNever(s);
  }
}
H.create = (e, t, r) => new H({
  schema: e,
  typeName: m.ZodEffects,
  effect: t,
  ...b(r)
});
H.createWithPreprocess = (e, t, r) => new H({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: m.ZodEffects,
  ...b(r)
});
class q extends T {
  _parse(t) {
    return this._getType(t) === h.undefined ? P(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
q.create = (e, t) => new q({
  innerType: e,
  typeName: m.ZodOptional,
  ...b(t)
});
class re extends T {
  _parse(t) {
    return this._getType(t) === h.null ? P(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
re.create = (e, t) => new re({
  innerType: e,
  typeName: m.ZodNullable,
  ...b(t)
});
class Xe extends T {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === h.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Xe.create = (e, t) => new Xe({
  innerType: e,
  typeName: m.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...b(t)
});
class et extends T {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return qe(s) ? s.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new L(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new L(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
et.create = (e, t) => new et({
  innerType: e,
  typeName: m.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...b(t)
});
class Ot extends T {
  _parse(t) {
    if (this._getType(t) !== h.nan) {
      const n = this._getOrReturnCtx(t);
      return p(n, {
        code: d.invalid_type,
        expected: h.nan,
        received: n.parsedType
      }), g;
    }
    return { status: "valid", value: t.data };
  }
}
Ot.create = (e) => new Ot({
  typeName: m.ZodNaN,
  ...b(e)
});
const vv = Symbol("zod_brand");
class Vr extends T {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class at extends T {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? g : i.status === "dirty" ? (r.dirty(), me(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? g : s.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new at({
      in: t,
      out: r,
      typeName: m.ZodPipeline
    });
  }
}
class tt extends T {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (s) => (He(s) && (s.value = Object.freeze(s.value)), s);
    return qe(r) ? r.then((s) => n(s)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
tt.create = (e, t) => new tt({
  innerType: e,
  typeName: m.ZodReadonly,
  ...b(t)
});
function Pa(e, t = {}, r) {
  return e ? _e.create().superRefine((n, s) => {
    var i, o;
    if (!e(n)) {
      const c = typeof t == "function" ? t(n) : typeof t == "string" ? { message: t } : t, u = (o = (i = c.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, l = typeof c == "string" ? { message: c } : c;
      s.addIssue({ code: "custom", ...l, fatal: u });
    }
  }) : _e.create();
}
const mv = {
  object: x.lazycreate
};
var m;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(m || (m = {}));
const gv = (e, t = {
  message: `Input not instance of ${e.name}`
}) => Pa((r) => r instanceof e, t), Va = U.create, Da = X.create, yv = Ot.create, _v = ee.create, La = Be.create, bv = ue.create, Tv = kt.create, $v = Ge.create, Av = ze.create, Sv = _e.create, Ev = ce.create, wv = W.create, xv = Rt.create, kv = Z.create, Rv = x.create, jv = x.strictCreate, Ov = Fe.create, Cv = zt.create, Iv = Ke.create, Mv = G.create, Nv = We.create, Pv = jt.create, Vv = le.create, Dv = ge.create, Lv = Qe.create, Uv = Je.create, Zv = te.create, Hv = Ye.create, qv = be.create, On = H.create, Bv = q.create, Gv = re.create, zv = H.createWithPreprocess, Fv = at.create, Kv = () => Va().optional(), Wv = () => Da().optional(), Qv = () => La().optional(), Jv = {
  string: (e) => U.create({ ...e, coerce: !0 }),
  number: (e) => X.create({ ...e, coerce: !0 }),
  boolean: (e) => Be.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => ee.create({ ...e, coerce: !0 }),
  date: (e) => ue.create({ ...e, coerce: !0 })
}, Yv = g;
var a = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: ye,
  setErrorMap: Yh,
  getErrorMap: Et,
  makeIssue: wt,
  EMPTY_PATH: Xh,
  addIssueToContext: p,
  ParseStatus: M,
  INVALID: g,
  DIRTY: me,
  OK: P,
  isAborted: _r,
  isDirty: br,
  isValid: He,
  isAsync: qe,
  get util() {
    return $;
  },
  get objectUtil() {
    return yr;
  },
  ZodParsedType: h,
  getParsedType: J,
  ZodType: T,
  datetimeRegex: Ma,
  ZodString: U,
  ZodNumber: X,
  ZodBigInt: ee,
  ZodBoolean: Be,
  ZodDate: ue,
  ZodSymbol: kt,
  ZodUndefined: Ge,
  ZodNull: ze,
  ZodAny: _e,
  ZodUnknown: ce,
  ZodNever: W,
  ZodVoid: Rt,
  ZodArray: Z,
  ZodObject: x,
  ZodUnion: Fe,
  ZodDiscriminatedUnion: zt,
  ZodIntersection: Ke,
  ZodTuple: G,
  ZodRecord: We,
  ZodMap: jt,
  ZodSet: le,
  ZodFunction: ge,
  ZodLazy: Qe,
  ZodLiteral: Je,
  ZodEnum: te,
  ZodNativeEnum: Ye,
  ZodPromise: be,
  ZodEffects: H,
  ZodTransformer: H,
  ZodOptional: q,
  ZodNullable: re,
  ZodDefault: Xe,
  ZodCatch: et,
  ZodNaN: Ot,
  BRAND: vv,
  ZodBranded: Vr,
  ZodPipeline: at,
  ZodReadonly: tt,
  custom: Pa,
  Schema: T,
  ZodSchema: T,
  late: mv,
  get ZodFirstPartyTypeKind() {
    return m;
  },
  coerce: Jv,
  any: Sv,
  array: kv,
  bigint: _v,
  boolean: La,
  date: bv,
  discriminatedUnion: Cv,
  effect: On,
  enum: Zv,
  function: Dv,
  instanceof: gv,
  intersection: Iv,
  lazy: Lv,
  literal: Uv,
  map: Pv,
  nan: yv,
  nativeEnum: Hv,
  never: wv,
  null: Av,
  nullable: Gv,
  number: Da,
  object: Rv,
  oboolean: Qv,
  onumber: Wv,
  optional: Bv,
  ostring: Kv,
  pipeline: Fv,
  preprocess: zv,
  promise: qv,
  record: Nv,
  set: Vv,
  strictObject: jv,
  string: Va,
  symbol: Tv,
  transformer: On,
  tuple: Mv,
  undefined: $v,
  union: Ov,
  unknown: Ev,
  void: xv,
  NEVER: Yv,
  ZodIssueCode: d,
  quotelessJson: Jh,
  ZodError: L
}), E = (e) => e, Xv = class {
  /**
   * @package
   */
  constructor(e, t, r) {
    this.versionMap = e, this.latestVersion = t, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(e) {
    let t = this.getVersion(e);
    if (t === null)
      return !1;
    const r = this.versionMap[t];
    return r ? r.schema.safeParse(e).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(e) {
    return this.versionMap[this.latestVersion].schema.safeParse(e).success;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(e) {
    const t = this.getVersion(e);
    if (t === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[t];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(e);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: t,
          versionDef: r,
          error: n.error
        }
      };
    let s = n.data;
    for (let i = t + 1; i <= this.latestVersion; i++) {
      const o = this.versionMap[i];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: i }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: i }
        };
      s = o.up(s);
    }
    return { type: "ok", value: s };
  }
};
function st(e) {
  return new Xv(e.versionMap, e.latestVersion, e.getVersion);
}
function Ct(e) {
  return a.custom((t) => e.is(t)).transform((t) => {
    const r = e.safeParse(t);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
var em = "__lodash_hash_undefined__";
function tm(e) {
  return this.__data__.set(e, em), this;
}
var rm = tm;
function nm(e) {
  return this.__data__.has(e);
}
var am = nm, sm = ua, im = rm, om = am;
function It(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new sm(); ++t < r; )
    this.add(e[t]);
}
It.prototype.add = It.prototype.push = im;
It.prototype.has = om;
var cm = It;
function um(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var lm = um;
function dm(e, t) {
  return e.has(t);
}
var fm = dm, pm = cm, hm = lm, vm = fm, mm = 1, gm = 2;
function ym(e, t, r, n, s, i) {
  var o = r & mm, c = e.length, u = t.length;
  if (c != u && !(o && u > c))
    return !1;
  var l = i.get(e), f = i.get(t);
  if (l && f)
    return l == t && f == e;
  var _ = -1, A = !0, I = r & gm ? new pm() : void 0;
  for (i.set(e, t), i.set(t, e); ++_ < c; ) {
    var V = e[_], D = t[_];
    if (n)
      var O = o ? n(D, V, _, t, e, i) : n(V, D, _, e, t, i);
    if (O !== void 0) {
      if (O)
        continue;
      A = !1;
      break;
    }
    if (I) {
      if (!hm(t, function(N, ie) {
        if (!vm(I, ie) && (V === N || s(V, N, r, n, i)))
          return I.push(ie);
      })) {
        A = !1;
        break;
      }
    } else if (!(V === D || s(V, D, r, n, i))) {
      A = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), A;
}
var Ua = ym;
function _m(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, s) {
    r[++t] = [s, n];
  }), r;
}
var bm = _m;
function Tm(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var $m = Tm, Cn = Lt, In = wa, Am = xr, Sm = Ua, Em = bm, wm = $m, xm = 1, km = 2, Rm = "[object Boolean]", jm = "[object Date]", Om = "[object Error]", Cm = "[object Map]", Im = "[object Number]", Mm = "[object RegExp]", Nm = "[object Set]", Pm = "[object String]", Vm = "[object Symbol]", Dm = "[object ArrayBuffer]", Lm = "[object DataView]", Mn = Cn ? Cn.prototype : void 0, ur = Mn ? Mn.valueOf : void 0;
function Um(e, t, r, n, s, i, o) {
  switch (r) {
    case Lm:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Dm:
      return !(e.byteLength != t.byteLength || !i(new In(e), new In(t)));
    case Rm:
    case jm:
    case Im:
      return Am(+e, +t);
    case Om:
      return e.name == t.name && e.message == t.message;
    case Mm:
    case Pm:
      return e == t + "";
    case Cm:
      var c = Em;
    case Nm:
      var u = n & xm;
      if (c || (c = wm), e.size != t.size && !u)
        return !1;
      var l = o.get(e);
      if (l)
        return l == t;
      n |= km, o.set(e, t);
      var f = Sm(c(e), c(t), n, s, i, o);
      return o.delete(e), f;
    case Vm:
      if (ur)
        return ur.call(e) == ur.call(t);
  }
  return !1;
}
var Zm = Um, Nn = Sa, Hm = 1, qm = Object.prototype, Bm = qm.hasOwnProperty;
function Gm(e, t, r, n, s, i) {
  var o = r & Hm, c = Nn(e), u = c.length, l = Nn(t), f = l.length;
  if (u != f && !o)
    return !1;
  for (var _ = u; _--; ) {
    var A = c[_];
    if (!(o ? A in t : Bm.call(t, A)))
      return !1;
  }
  var I = i.get(e), V = i.get(t);
  if (I && V)
    return I == t && V == e;
  var D = !0;
  i.set(e, t), i.set(t, e);
  for (var O = o; ++_ < u; ) {
    A = c[_];
    var N = e[A], ie = t[A];
    if (n)
      var rn = o ? n(ie, N, A, t, e, i) : n(N, ie, A, e, t, i);
    if (!(rn === void 0 ? N === ie || s(N, ie, r, n, i) : rn)) {
      D = !1;
      break;
    }
    O || (O = A == "constructor");
  }
  if (D && !O) {
    var mt = e.constructor, gt = t.constructor;
    mt != gt && "constructor" in e && "constructor" in t && !(typeof mt == "function" && mt instanceof mt && typeof gt == "function" && gt instanceof gt) && (D = !1);
  }
  return i.delete(e), i.delete(t), D;
}
var zm = Gm, lr = la, Fm = Ua, Km = Zm, Wm = zm, Pn = Gt, Vn = Bt, Dn = Rr, Qm = va, Jm = 1, Ln = "[object Arguments]", Un = "[object Array]", _t = "[object Object]", Ym = Object.prototype, Zn = Ym.hasOwnProperty;
function Xm(e, t, r, n, s, i) {
  var o = Vn(e), c = Vn(t), u = o ? Un : Pn(e), l = c ? Un : Pn(t);
  u = u == Ln ? _t : u, l = l == Ln ? _t : l;
  var f = u == _t, _ = l == _t, A = u == l;
  if (A && Dn(e)) {
    if (!Dn(t))
      return !1;
    o = !0, f = !1;
  }
  if (A && !f)
    return i || (i = new lr()), o || Qm(e) ? Fm(e, t, r, n, s, i) : Km(e, t, u, r, n, s, i);
  if (!(r & Jm)) {
    var I = f && Zn.call(e, "__wrapped__"), V = _ && Zn.call(t, "__wrapped__");
    if (I || V) {
      var D = I ? e.value() : e, O = V ? t.value() : t;
      return i || (i = new lr()), s(D, O, r, n, i);
    }
  }
  return A ? (i || (i = new lr()), Wm(e, t, r, n, s, i)) : !1;
}
var eg = Xm, tg = eg, Hn = Re;
function Za(e, t, r, n, s) {
  return e === t ? !0 : e == null || t == null || !Hn(e) && !Hn(t) ? e !== e && t !== t : tg(e, t, r, n, Za, s);
}
var rg = Za, ng = rg;
function ag(e, t) {
  return ng(e, t);
}
var sg = ag;
const ig = /* @__PURE__ */ aa(sg), og = (e) => ({
  equals(t, r) {
    return t !== void 0 && r !== void 0 ? e.equals(t, r) : t === void 0 && r === void 0;
  }
}), dr = (e, t) => ({
  equals(r, n) {
    return t.equals(e(r), e(n));
  }
}), he = {
  equals(e, t) {
    return ig(e, t);
  }
}, cg = a.object({
  id: a.optional(a.string()),
  // Firebase Firestore ID
  url: a.string(),
  path: a.string(),
  headers: a.array(
    a.object({
      key: a.string(),
      value: a.string(),
      active: a.boolean()
    })
  ),
  params: a.array(
    a.object({
      key: a.string(),
      value: a.string(),
      active: a.boolean()
    })
  ),
  name: a.string(),
  method: a.string(),
  preRequestScript: a.string(),
  testScript: a.string(),
  contentType: a.string(),
  body: a.string(),
  rawParams: a.optional(a.string()),
  auth: a.optional(a.string()),
  httpUser: a.optional(a.string()),
  httpPassword: a.optional(a.string()),
  bearerToken: a.optional(a.string())
}), qn = E({
  initial: !0,
  schema: cg
}), Dr = a.object({
  key: a.string(),
  active: a.boolean()
}).and(
  a.union([
    a.object({
      isFile: a.literal(!0),
      value: a.array(a.instanceof(Blob).nullable())
    }),
    a.object({
      isFile: a.literal(!1),
      value: a.string()
    })
  ])
);
a.object({
  contentType: a.literal("multipart/form-data"),
  body: a.array(Dr)
});
const ug = a.union([
  a.object({
    contentType: a.literal(null),
    body: a.literal(null).catch(null)
  }),
  a.object({
    contentType: a.literal("multipart/form-data"),
    body: a.array(Dr).catch([])
  }),
  a.object({
    contentType: a.union([
      a.literal("application/json"),
      a.literal("application/ld+json"),
      a.literal("application/hal+json"),
      a.literal("application/vnd.api+json"),
      a.literal("application/xml"),
      a.literal("application/x-www-form-urlencoded"),
      a.literal("text/html"),
      a.literal("text/plain")
    ]),
    body: a.string().catch("")
  })
]), Oe = a.object({
  authType: a.literal("none")
}), Ce = a.object({
  authType: a.literal("basic"),
  username: a.string().catch(""),
  password: a.string().catch("")
}), Ie = a.object({
  authType: a.literal("bearer"),
  token: a.string().catch("")
}), lg = a.object({
  authType: a.literal("oauth-2"),
  token: a.string().catch(""),
  oidcDiscoveryURL: a.string().catch(""),
  authURL: a.string().catch(""),
  accessTokenURL: a.string().catch(""),
  clientID: a.string().catch(""),
  scope: a.string().catch("")
}), it = a.object({
  authType: a.literal("api-key"),
  key: a.string().catch(""),
  value: a.string().catch(""),
  addTo: a.string().catch("Headers")
}), Me = a.object({
  authType: a.literal("inherit")
}), dg = a.discriminatedUnion("authType", [
  Oe,
  Me,
  Ce,
  Ie,
  lg,
  it
]).and(
  a.object({
    authActive: a.boolean()
  })
), fg = a.array(
  a.object({
    key: a.string().catch(""),
    value: a.string().catch(""),
    active: a.boolean().catch(!0)
  })
), Ha = a.array(
  a.object({
    key: a.string().catch(""),
    value: a.string().catch(""),
    active: a.boolean().catch(!0)
  })
), qa = a.object({
  v: a.literal("1"),
  id: a.optional(a.string()),
  // Firebase Firestore ID
  name: a.string(),
  method: a.string(),
  endpoint: a.string(),
  params: fg,
  headers: Ha,
  preRequestScript: a.string().catch(""),
  testScript: a.string().catch(""),
  auth: dg,
  body: ug
});
function pg(e) {
  return {
    contentType: "application/json",
    body: e.contentType === "application/json" ? e.rawParams ?? "" : ""
  };
}
function hg(e) {
  return !e.auth || e.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : e.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: e.httpUser ?? "",
    password: e.httpPassword ?? ""
  } : e.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: e.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const vg = E({
  initial: !1,
  schema: qa,
  up(e) {
    const {
      url: t,
      path: r,
      headers: n,
      params: s,
      name: i,
      method: o,
      preRequestScript: c,
      testScript: u
    } = e, l = `${t}${r}`, f = pg(e), _ = hg(e), A = {
      v: "1",
      endpoint: l,
      headers: n,
      params: s,
      name: i,
      method: o,
      preRequestScript: c,
      testScript: u,
      body: f,
      auth: _
    };
    return e.id && (A.id = e.id), A;
  }
}), Ft = a.array(
  a.object({
    key: a.string().catch(""),
    value: a.string().catch(""),
    active: a.boolean().catch(!0)
  })
), Ba = qa.extend({
  v: a.literal("2"),
  requestVariables: Ft
}), mg = E({
  initial: !1,
  schema: Ba,
  up(e) {
    return {
      ...e,
      v: "2",
      requestVariables: []
    };
  }
}), Ga = a.object({
  grantType: a.literal("AUTHORIZATION_CODE"),
  authEndpoint: a.string().trim(),
  tokenEndpoint: a.string().trim(),
  clientID: a.string().trim(),
  clientSecret: a.string().trim(),
  scopes: a.string().trim().optional(),
  token: a.string().catch(""),
  isPKCE: a.boolean(),
  codeVerifierMethod: a.union([a.literal("plain"), a.literal("S256")]).optional()
}), Kt = a.object({
  grantType: a.literal("CLIENT_CREDENTIALS"),
  authEndpoint: a.string().trim(),
  clientID: a.string().trim(),
  clientSecret: a.string().trim(),
  scopes: a.string().trim().optional(),
  token: a.string().catch("")
}), Wt = a.object({
  grantType: a.literal("PASSWORD"),
  authEndpoint: a.string().trim(),
  clientID: a.string().trim(),
  clientSecret: a.string().trim(),
  scopes: a.string().trim().optional(),
  username: a.string().trim(),
  password: a.string().trim(),
  token: a.string().catch("")
}), Qt = a.object({
  grantType: a.literal("IMPLICIT"),
  authEndpoint: a.string().trim(),
  clientID: a.string().trim(),
  scopes: a.string().trim().optional(),
  token: a.string().catch("")
}), Jt = a.object({
  authType: a.literal("oauth-2"),
  grantTypeInfo: a.discriminatedUnion("grantType", [
    Ga,
    Kt,
    Wt,
    Qt
  ]),
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), gg = a.discriminatedUnion("authType", [
  Oe,
  Me,
  Ce,
  Ie,
  Jt,
  it
]).and(
  a.object({
    authActive: a.boolean()
  })
), za = Ba.extend({
  v: a.literal("3"),
  auth: gg
}), yg = E({
  initial: !1,
  schema: za,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: s, authURL: i } = e.auth;
      return {
        ...e,
        v: "3",
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: i,
            tokenEndpoint: r,
            clientID: s,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: "3",
      auth: {
        ...e.auth
      }
    };
  }
}), Fa = it.extend({
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), _g = a.discriminatedUnion("authType", [
  Oe,
  Me,
  Ce,
  Ie,
  Jt,
  Fa
]).and(
  a.object({
    authActive: a.boolean()
  })
), Ka = za.extend({
  v: a.literal("4"),
  auth: _g
}), bg = E({
  schema: Ka,
  initial: !1,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: "4",
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      auth: {
        ...e.auth
      },
      v: "4"
    };
  }
}), Wa = Ga.extend({
  clientSecret: a.string().optional()
}), Yt = Jt.extend({
  grantTypeInfo: a.discriminatedUnion("grantType", [
    Wa,
    Kt,
    Wt,
    Qt
  ])
}), Qa = a.discriminatedUnion("authType", [
  Oe,
  Me,
  Ce,
  Ie,
  Yt,
  Fa
]).and(
  a.object({
    authActive: a.boolean()
  })
), Ja = Ka.extend({
  v: a.literal("5"),
  auth: Qa
}), Tg = E({
  schema: Ja,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Ya = a.union([
  a.object({
    contentType: a.literal(null),
    body: a.literal(null).catch(null)
  }),
  a.object({
    contentType: a.literal("multipart/form-data"),
    body: a.array(Dr).catch([])
  }),
  a.object({
    contentType: a.union([
      a.literal("application/json"),
      a.literal("application/ld+json"),
      a.literal("application/hal+json"),
      a.literal("application/vnd.api+json"),
      a.literal("application/xml"),
      a.literal("text/xml"),
      a.literal("application/x-www-form-urlencoded"),
      a.literal("text/html"),
      a.literal("text/plain")
    ]),
    body: a.string().catch("")
  })
]), Xa = Ja.extend({
  v: a.literal("6"),
  body: Ya
}), $g = E({
  schema: Xa,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "6"
    };
  }
}), es = Wa.extend({
  refreshToken: a.string().optional()
}), ts = a.object({
  authType: a.literal("oauth-2"),
  grantTypeInfo: a.discriminatedUnion("grantType", [
    es,
    Kt,
    Wt,
    Qt
  ]),
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Xt = a.array(
  a.object({
    key: a.string().catch(""),
    value: a.string().catch(""),
    active: a.boolean().catch(!0),
    description: a.string().catch("")
  })
), ot = a.array(
  a.object({
    key: a.string().catch(""),
    value: a.string().catch(""),
    active: a.boolean().catch(!0),
    description: a.string().catch("")
  })
), Lr = a.object({
  authType: a.literal("aws-signature"),
  accessKey: a.string().catch(""),
  secretKey: a.string().catch(""),
  region: a.string().catch(""),
  serviceName: a.string().catch(""),
  serviceToken: a.string().optional(),
  signature: a.object({}).optional(),
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), rs = a.discriminatedUnion("authType", [
  Oe,
  Me,
  Ce,
  Ie,
  ts,
  it,
  Lr
]).and(
  a.object({
    authActive: a.boolean()
  })
), ns = Xa.extend({
  v: a.literal("7"),
  params: Xt,
  headers: ot,
  auth: rs
}), Ag = E({
  schema: ns,
  initial: !1,
  up(e) {
    const t = e.params.map((n) => ({
      ...n,
      description: ""
    })), r = e.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...e,
      v: "7",
      params: t,
      headers: r
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), Sg = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, Eg = Kt.extend({
  clientSecret: a.string().optional()
}), wg = Wt.extend({
  clientSecret: a.string().optional()
}), xg = a.object({
  authType: a.literal("oauth-2"),
  grantTypeInfo: a.discriminatedUnion("grantType", [
    es,
    Eg,
    wg,
    Qt
  ]),
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), kg = a.object({
  authType: a.literal("digest"),
  username: a.string().catch(""),
  password: a.string().catch(""),
  realm: a.string().catch(""),
  nonce: a.string().catch(""),
  algorithm: a.enum(["MD5", "MD5-sess"]).catch("MD5"),
  qop: a.enum(["auth", "auth-int"]).catch("auth"),
  nc: a.string().catch(""),
  cnonce: a.string().catch(""),
  opaque: a.string().catch(""),
  disableRetry: a.boolean().catch(!1)
}), ct = a.discriminatedUnion("authType", [
  Oe,
  Me,
  Ce,
  Ie,
  xg,
  it,
  Lr,
  kg
]).and(
  a.object({
    authActive: a.boolean()
  })
), as = a.union(
  Object.keys(Sg).map((e) => a.literal(parseInt(e)))
), ss = a.array(
  a.object({
    key: a.string(),
    value: a.string()
  })
), Rg = a.object({
  v: a.literal("1"),
  name: a.string(),
  method: a.string(),
  endpoint: a.string(),
  headers: ot,
  params: Xt,
  body: Ya,
  auth: ct,
  requestVariables: Ft
}), jg = a.object({
  name: a.string(),
  originalRequest: Rg,
  status: a.string(),
  code: a.optional(as),
  headers: ss,
  body: a.string()
}), Og = a.record(
  a.string(),
  jg
), is = ns.extend({
  v: a.literal("8"),
  auth: ct,
  responses: Og
}), Cg = E({
  schema: is,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), Ig = a.object({
  key: a.string(),
  active: a.boolean(),
  contentType: a.string().optional().catch(void 0)
}).and(
  a.union([
    a.object({
      isFile: a.literal(!0),
      value: a.array(a.instanceof(Blob).nullable())
    }),
    a.object({
      isFile: a.literal(!1),
      value: a.string()
    })
  ])
), Ur = a.union([
  a.object({
    contentType: a.literal(null),
    body: a.literal(null).catch(null)
  }),
  a.object({
    contentType: a.literal("multipart/form-data"),
    body: a.array(Ig).catch([]),
    showIndividualContentType: a.boolean().optional().catch(!1)
  }),
  a.object({
    contentType: a.literal("application/octet-stream"),
    body: a.instanceof(File).nullable().catch(null)
  }),
  a.object({
    contentType: a.union([
      a.literal("application/json"),
      a.literal("application/ld+json"),
      a.literal("application/hal+json"),
      a.literal("application/vnd.api+json"),
      a.literal("application/xml"),
      a.literal("text/xml"),
      a.literal("application/x-www-form-urlencoded"),
      a.literal("binary"),
      a.literal("text/html"),
      a.literal("text/plain")
    ]),
    body: a.string().catch("")
  })
]), Mg = a.object({
  v: a.literal("2"),
  name: a.string(),
  method: a.string(),
  endpoint: a.string(),
  headers: ot,
  params: Xt,
  body: Ur,
  auth: ct,
  requestVariables: Ft
}), Ng = a.object({
  name: a.string(),
  originalRequest: Mg,
  status: a.string(),
  code: a.optional(as),
  headers: ss,
  body: a.string()
}), os = a.record(
  a.string(),
  Ng
), Pg = is.extend({
  v: a.literal("9"),
  body: Ur,
  responses: os
}), Vg = E({
  schema: Pg,
  initial: !1,
  up(e) {
    const t = Object.fromEntries(
      Object.entries(e.responses).map(([r, n]) => [
        r,
        {
          ...n,
          originalRequest: {
            ...n.originalRequest,
            v: "2"
          }
        }
      ])
    );
    return {
      ...e,
      v: "9",
      responses: t
    };
  }
}), Dg = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "application/octet-stream": "binary",
  "text/html": "html",
  "text/plain": "plain"
}, U_ = Object.keys(
  Dg
), Lg = a.object({
  // v is a stringified number
  v: a.string().regex(/^\d+$/).transform(Number)
}), er = st({
  latestVersion: 9,
  versionMap: {
    0: qn,
    1: vg,
    2: mg,
    3: yg,
    4: bg,
    5: Tg,
    6: $g,
    7: Ag,
    8: Cg,
    9: Vg
  },
  getVersion(e) {
    const t = Lg.safeParse(e);
    return t.success ? t.data.v : qn.schema.safeParse(e).success ? 0 : null;
  }
}), Ug = ai({
  id: og(Q),
  v: Q,
  auth: he,
  body: he,
  endpoint: Q,
  headers: dr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    he
  ),
  params: dr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    he
  ),
  method: Q,
  name: Q,
  preRequestScript: Q,
  testScript: Q,
  requestVariables: dr(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    he
  ),
  responses: he
}), cs = "9", Z_ = Ug.equals;
function H_(e, t) {
  const r = Qh(t);
  if (e && typeof e == "object") {
    if ("id" in e && typeof e.id == "string" && (r.id = e.id), "name" in e && typeof e.name == "string" && (r.name = e.name), "method" in e && typeof e.method == "string" && (r.method = e.method), "endpoint" in e && typeof e.endpoint == "string" && (r.endpoint = e.endpoint), "preRequestScript" in e && typeof e.preRequestScript == "string" && (r.preRequestScript = e.preRequestScript), "testScript" in e && typeof e.testScript == "string" && (r.testScript = e.testScript), "body" in e) {
      const n = Ur.safeParse(e.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in e) {
      const n = ct.safeParse(e.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in e) {
      const n = Xt.safeParse(e.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in e) {
      const n = ot.safeParse(e.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in e) {
      const n = Ft.safeParse(e.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
    if ("responses" in e) {
      const n = os.safeParse(e.responses);
      n.success && (r.responses = n.data);
    }
  }
  return r;
}
function q_(e) {
  return {
    v: cs,
    ...e
  };
}
function Zg() {
  return {
    v: cs,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: [],
    responses: {}
  };
}
function B_(e) {
  return er.isLatest(e);
}
function Hg(e) {
  const t = er.safeParse(e);
  return t.type === "ok" ? t.value : Zg();
}
const Zr = a.object({
  key: a.string().catch(""),
  value: a.string().catch(""),
  active: a.boolean().catch(!0)
}), qg = a.object({
  v: a.literal(1),
  name: a.string(),
  url: a.string(),
  headers: a.array(Zr).catch([]),
  query: a.string(),
  variables: a.string()
}), Bg = E({
  initial: !0,
  schema: qg
}), Ne = a.object({
  authType: a.literal("none")
}), Pe = a.object({
  authType: a.literal("basic"),
  username: a.string().catch(""),
  password: a.string().catch("")
}), Ve = a.object({
  authType: a.literal("bearer"),
  token: a.string().catch("")
}), Gg = a.object({
  authType: a.literal("oauth-2"),
  token: a.string().catch(""),
  oidcDiscoveryURL: a.string().catch(""),
  authURL: a.string().catch(""),
  accessTokenURL: a.string().catch(""),
  clientID: a.string().catch(""),
  scope: a.string().catch("")
}), Hr = a.object({
  authType: a.literal("api-key"),
  key: a.string().catch(""),
  value: a.string().catch(""),
  addTo: a.string().catch("Headers")
}), De = a.object({
  authType: a.literal("inherit")
}), zg = a.discriminatedUnion("authType", [
  Ne,
  Pe,
  Ve,
  Gg,
  Hr,
  De
]).and(
  a.object({
    authActive: a.boolean()
  })
), us = a.object({
  id: a.optional(a.string()),
  v: a.literal(2),
  name: a.string(),
  url: a.string(),
  headers: a.array(Zr).catch([]),
  query: a.string(),
  variables: a.string(),
  auth: zg
}), Fg = E({
  initial: !1,
  schema: us,
  up(e) {
    return {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), Kg = a.discriminatedUnion("authType", [
  Ne,
  De,
  Pe,
  Ve,
  Hr,
  Jt
  // both rest and gql have the same auth type for oauth2
]).and(
  a.object({
    authActive: a.boolean()
  })
), ls = us.extend({
  v: a.literal(3),
  auth: Kg
}), Wg = E({
  initial: !1,
  schema: ls,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: s, authURL: i } = e.auth;
      return {
        ...e,
        v: 3,
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: i,
            tokenEndpoint: r,
            clientID: s,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: 3,
      auth: {
        ...e.auth
      }
    };
  }
}), tr = Hr.extend({
  addTo: a.enum(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Qg = a.discriminatedUnion("authType", [
  Ne,
  De,
  Pe,
  Ve,
  tr,
  Yt
  // both rest and gql have the same auth type for oauth2
]).and(
  a.object({
    authActive: a.boolean()
  })
), ds = ls.extend({
  v: a.literal(4),
  auth: Qg
}), Jg = E({
  initial: !1,
  schema: ds,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: 4,
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      v: 4,
      auth: {
        ...e.auth
      }
    };
  }
}), fs = a.discriminatedUnion("authType", [
  Ne,
  De,
  Pe,
  Ve,
  tr,
  Yt
  // both rest and gql have the same auth type for oauth2
]).and(
  a.object({
    authActive: a.boolean()
  })
), ps = ds.extend({
  v: a.literal(5),
  auth: fs
}), Yg = E({
  initial: !1,
  schema: ps,
  up(e) {
    return {
      ...e,
      v: 5
    };
  }
}), hs = Lr, vs = a.object({
  key: a.string().catch(""),
  value: a.string().catch(""),
  active: a.boolean().catch(!0),
  description: a.string().catch("")
}), ms = a.discriminatedUnion("authType", [
  Ne,
  De,
  Pe,
  Ve,
  Yt,
  tr,
  hs
]).and(
  a.object({
    authActive: a.boolean()
  })
), gs = ps.extend({
  v: a.literal(6),
  auth: ms,
  headers: a.array(vs).catch([])
}), Xg = E({
  schema: gs,
  initial: !1,
  up(e) {
    const t = e.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...e,
      v: 6,
      headers: t
    };
  }
}), ys = a.discriminatedUnion("authType", [
  Ne,
  De,
  Pe,
  Ve,
  ts,
  tr,
  hs
]).and(
  a.object({
    authActive: a.boolean()
  })
), ey = gs.extend({
  v: a.literal(7),
  auth: ys
}), ty = E({
  schema: ey,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), _s = 7, ry = a.object({
  v: a.number()
}), qr = st({
  latestVersion: 7,
  versionMap: {
    1: Bg,
    2: Fg,
    3: Wg,
    4: Jg,
    5: Yg,
    6: Xg,
    7: ty
  },
  getVersion(e) {
    const t = ry.safeParse(e);
    return t.success ? t.data.v : null;
  }
}), ny = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function ay() {
  return {
    v: _s,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: ny,
    auth: {
      authType: "inherit",
      authActive: !0
    }
  };
}
function sy(e) {
  const t = qr.safeParse(e);
  return t.type === "ok" ? t.value : ay();
}
function G_(e) {
  return {
    v: _s,
    ...e
  };
}
const iy = a.object({
  v: a.literal(1),
  id: a.optional(a.string()),
  // For Firestore ID data
  name: a.string(),
  requests: a.array(
    a.lazy(
      () => a.union([
        Ct(er),
        Ct(qr)
      ])
    )
  )
}), bs = iy.extend({
  folders: a.lazy(() => a.array(bs))
}), Bn = E({
  initial: !0,
  schema: bs
}), Ts = a.object({
  v: a.literal(2),
  id: a.optional(a.string()),
  // For Firestore ID data
  name: a.string(),
  requests: a.array(
    a.lazy(
      () => a.union([
        Ct(er),
        Ct(qr)
      ])
    )
  ),
  auth: a.union([Qa, fs]),
  headers: a.union([Ha, a.array(Zr)])
}), $s = Ts.extend({
  folders: a.lazy(() => a.array($s))
}), oy = E({
  initial: !1,
  schema: $s,
  up(e) {
    const t = {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: []
    };
    return e.id && (t.id = e.id), t;
  }
}), As = Ts.extend({
  v: a.literal(3),
  // AWS Signature Authorization type addition
  auth: a.union([rs, ms]),
  // `description` field addition under `headers`
  headers: a.union([ot, a.array(vs)])
}), Ss = As.extend({
  folders: a.lazy(() => a.array(Ss))
}), cy = E({
  initial: !1,
  schema: Ss,
  up(e) {
    const t = e.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...e,
      v: 3,
      headers: t
    };
  }
}), Es = As.extend({
  v: a.literal(4),
  auth: a.union([ct, ys])
}), ws = Es.extend({
  folders: a.lazy(() => a.array(ws))
}), uy = E({
  initial: !1,
  schema: ws,
  // @ts-expect-error
  up(e) {
    return {
      ...e,
      v: 4
    };
  }
});
var C = [];
for (var fr = 0; fr < 256; ++fr)
  C.push((fr + 256).toString(16).slice(1));
function ly(e, t = 0) {
  return (C[e[t + 0]] + C[e[t + 1]] + C[e[t + 2]] + C[e[t + 3]] + "-" + C[e[t + 4]] + C[e[t + 5]] + "-" + C[e[t + 6]] + C[e[t + 7]] + "-" + C[e[t + 8]] + C[e[t + 9]] + "-" + C[e[t + 10]] + C[e[t + 11]] + C[e[t + 12]] + C[e[t + 13]] + C[e[t + 14]] + C[e[t + 15]]).toLowerCase();
}
var bt, dy = new Uint8Array(16);
function fy() {
  if (!bt && (bt = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !bt))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return bt(dy);
}
var py = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const Gn = {
  randomUUID: py
};
function hy(e, t, r) {
  if (Gn.randomUUID && !t && !e)
    return Gn.randomUUID();
  e = e || {};
  var n = e.random || (e.rng || fy)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, ly(n);
}
const xs = (e = "") => {
  const t = Date.now().toString(36), r = hy();
  return `${e}_${t}_${r}`;
}, vy = Es.extend({
  v: a.literal(5),
  _ref_id: a.string().optional()
}), ks = vy.extend({
  folders: a.lazy(() => a.array(ks))
}), my = E({
  initial: !1,
  schema: ks,
  // @ts-expect-error
  up(e) {
    return {
      ...e,
      v: 5,
      _ref_id: xs("coll")
    };
  }
}), gy = a.object({
  v: a.number()
}), z_ = st({
  latestVersion: 5,
  versionMap: {
    1: Bn,
    2: oy,
    3: cy,
    4: uy,
    5: my
  },
  getVersion(e) {
    const t = gy.safeParse(e);
    return t.success ? t.data.v : Bn.schema.safeParse(e).success ? 1 : null;
  }
}), yy = 5;
function Rs(e) {
  return {
    v: yy,
    ...e,
    _ref_id: e._ref_id ? e._ref_id : xs("coll")
  };
}
function _y(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(_y), n = (e.requests ?? []).map(Hg), s = e.auth ?? { authType: "inherit", authActive: !0 }, i = e.headers ?? [], o = Rs({
    name: t,
    folders: r,
    requests: n,
    auth: s,
    headers: i
  });
  return e.id && (o.id = e.id), e._ref_id && (o._ref_id = e._ref_id), o;
}
function by(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(by), n = (e.requests ?? []).map(sy), s = e.auth ?? { authType: "inherit", authActive: !0 }, i = e.headers ?? [], o = Rs({
    name: t,
    folders: r,
    requests: n,
    auth: s,
    headers: i
  });
  return e.id && (o.id = e.id), e._ref_id && (o._ref_id = e._ref_id), o;
}
var ae = function(e) {
  return function(t) {
    return !e(t);
  };
}, Ty = _i, $y = gi;
function js(e, t) {
  return t === void 0 ? function(r) {
    return js(e, r);
  } : $y(e, t) ? ea : ta(t[e]);
}
var Os = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, Ay = function(e) {
  return function(t) {
    for (var r = [], n = 0; n < t.length; n++) {
      var s = e(n, t[n]);
      Xn(s) && r.push(s.value);
    }
    return r;
  };
}, Sy = function(e) {
  return Ay(function(t, r) {
    return e(r);
  });
}, Cs = function(e) {
  return e.slice();
}, Ey = mi, zn = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, s = t.length, i; n < s; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}, wy = function(e) {
  return function(t) {
    return zn(zn([], t, !0), [e], !1);
  };
}, xy = wy, ky = function(e) {
  return [e];
}, Ry = xy, jy = js, Oy = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, Cy = function() {
  return {
    concat: function(e, t) {
      return e.concat(t);
    }
  };
}, Iy = function() {
  return {
    concat: Cy().concat,
    empty: []
  };
}, rr = ea, ut = ta;
function Is(e) {
  return function(t) {
    return e(t) ? ut(t) : rr;
  };
}
var $r = function(e) {
  return function(t) {
    return Ms(t) ? rr : ut(e(t.value));
  };
}, My = Xn, Ms = function(e) {
  return e._tag === "None";
}, Ny = function(e, t) {
  return function(r) {
    return Ms(r) ? e() : t(r.value);
  };
}, Py = Ny, Br = Py, Vy = function(e, t) {
  for (var r = t(e); r._tag === "Left"; )
    r = t(r.left);
  return r.right;
}, se = oi, z = ci, Dy = /* @__PURE__ */ ri(2, function(e, t) {
  return Te(e) ? e : t(e.right);
}), lt = function(e) {
  return function(t) {
    return Te(t) ? t : z(e(t.right));
  };
}, nr = function(e) {
  return function(t) {
    return Te(t) ? se(e(t.left)) : t;
  };
}, Te = si, Ly = ii, Uy = function(e) {
  return function(t) {
    return Te(t) ? e(t.left) : t.right;
  };
}, Gr = Uy, Fn = Dy, Mt = function() {
  return Mt = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, Mt.apply(this, arguments);
}, dt = function(e, t, r) {
  return z({
    value: e,
    next: t,
    start: r
  });
}, ft = function(e, t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = !1), se({
    input: e,
    expected: t,
    fatal: r
  });
}, Zy = function(e, t) {
  return Mt(Mt({}, e), { expected: t });
}, Hy = function(e, t) {
  return qy().concat(e, t);
}, qy = function() {
  return {
    concat: function(e, t) {
      return e.input.cursor < t.input.cursor ? hi().concat(e, t) : e.input.cursor > t.input.cursor ? ir().concat(e, t) : pi({
        input: ir(),
        fatal: ir(),
        expected: Iy()
      }).concat(e, t);
    }
  };
}, By = function(e, t) {
  return t === void 0 && (t = 0), {
    buffer: e,
    cursor: t
  };
}, Gy = function(e) {
  return jy(e.cursor, e.buffer);
}, zy = function(e) {
  return e.cursor >= e.buffer.length;
}, Fy = function(e) {
  return y(Gy(e), $r(function(t) {
    return { value: t, next: { buffer: e.buffer, cursor: e.cursor + 1 } };
  }));
}, ne = function() {
  return ne = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, ne.apply(this, arguments);
}, zr = function(e) {
  return function(t) {
    return dt(e, t, t);
  };
}, Ky = function() {
  return function(e) {
    return ft(e);
  };
}, Wy = function(e) {
  return function() {
    return ft(e);
  };
}, j = function(e) {
  return y(Yy(Qy()), fe(function(t) {
    var r = t[0], n = t[1];
    return e(r) ? $e(r) : Wy(n);
  }));
}, R = function(e, t) {
  return function(r) {
    return y(e(r), nr(function(n) {
      return Zy(n, [t]);
    }));
  };
}, Qy = function() {
  return function(e) {
    return y(Fy(e), Br(function() {
      return ft(e);
    }, function(t) {
      var r = t.value, n = t.next;
      return dt(r, n, e);
    }));
  };
}, Jy = function(e, t) {
  return function(r) {
    return y(e(r), Fn(function(n) {
      return y(t(n.value)(n.next), Fn(function(s) {
        return dt(s.value, s.next, r);
      }));
    }));
  };
}, ar = function(e, t) {
  return function(r) {
    var n = e(r);
    return Ly(n) || n.left.fatal ? n : y(t()(r), nr(function(s) {
      return Hy(n.left, s);
    }));
  };
}, Yy = function(e) {
  return function(t) {
    return y(e(t), lt(function(r) {
      return ne(ne({}, r), { value: [r.value, t] });
    }));
  };
}, Ns = function(e) {
  return pe(function() {
    return $e(e.empty);
  });
}, Fr = function() {
  return R(function(e) {
    return zy(e) ? dt(void 0, e, e) : ft(e);
  }, "end of file");
}, Xy = function(e) {
  return y(Kr(e), pe(function() {
    return $e([]);
  }));
}, Kr = function(e) {
  return y(e, fe(function(t) {
    return Qr(ky(t), function(r) {
      return y(e, k(function(n) {
        return se(Ry(n)(r));
      }), pe(function() {
        return $e(z(r));
      }));
    });
  }));
}, e_ = function(e, t) {
  return function(r) {
    return y(e, fe(function() {
      return r;
    }), Jr(function() {
      return t;
    }));
  };
}, Ps = function(e) {
  return e_(e, e);
}, t_ = function(e) {
  return Xy(j(ae(e)));
}, Wr = function(e, t) {
  return y(t, k(function() {
    return Ey;
  }), pe(function() {
    return r_(e, t);
  }));
}, r_ = function(e, t) {
  return y(e, fe(function(r) {
    return Qr(bi(r), function(n) {
      return y(t, k(function() {
        return z(n);
      }), pe(function() {
        return y(e, k(function(s) {
          return se(Ty(s)(n));
        }));
      }));
    });
  }));
}, pt = function(e, t) {
  return function(r) {
    return y(e(r), lt(function(n) {
      return ne(ne({}, n), { value: t(n.value) });
    }));
  };
}, Vs = function(e, t) {
  return sr(e, function(r) {
    return pt(t, r);
  });
}, sr = function(e, t) {
  return Jy(e, t);
}, Qr = function(e, t) {
  var r = function(n) {
    return function(s) {
      return Te(s.value) ? se({ value: s.value.left, stream: s.next }) : z(dt(s.value.right, s.next, n));
    };
  };
  return function(n) {
    return Vy({ value: e, stream: n }, function(s) {
      var i = t(s.value)(s.stream);
      return Te(i) ? z(ft(s.stream, i.left.expected, i.left.fatal)) : r(n)(i.right);
    });
  };
}, n_ = function(e, t) {
  return ar(e, t);
}, k = function(e) {
  return function(t) {
    return pt(t, e);
  };
}, $e = zr, fe = function(e) {
  return function(t) {
    return sr(t, e);
  };
}, Jr = function(e) {
  return function(t) {
    return sr(t, function(r) {
      return pt(e(r), function() {
        return r;
      });
    });
  };
}, pe = function(e) {
  return function(t) {
    return n_(t, e);
  };
}, a_ = "Parser", s_ = function(e) {
  return {
    concat: function(t, r) {
      return Vs(pt(t, function(n) {
        return function(s) {
          return e.concat(n, s);
        };
      }), r);
    }
  };
}, i_ = function(e) {
  return ne(ne({}, s_(e)), { empty: zr(e.empty) });
}, o_ = {
  URI: a_,
  map: pt,
  ap: Vs,
  chain: sr,
  chainRec: Qr
}, Ds = function(e, t, r) {
  var n;
  return Object.assign({}, e, (n = {}, n[t] = r, n));
}, Ls = function(e) {
  return function(t) {
    return y(t, k(function(r) {
      return Ds({}, e, r);
    }));
  };
}, Ar = function(e, t) {
  return function(r) {
    return y(r, fe(function(n) {
      return y(t(n), k(function(s) {
        return Ds(n, e, s);
      }));
    }));
  };
}, c_ = function(e) {
  return vi(e)(e.empty);
}, u_ = Ns(wr), Ae = function(e) {
  return R(j(function(t) {
    return t === e;
  }), '"'.concat(e, '"'));
}, l_ = function(e) {
  return R(j(function(t) {
    return t !== e;
  }), 'anything but "'.concat(e, '"'));
}, Yr = function(e) {
  return u_(ht(e));
}, ht = function(e) {
  return y(Kr(e), k(function(t) {
    return t.join("");
  }));
}, Xr = function(e) {
  return "0123456789".indexOf(e) !== -1;
}, Sr = R(j(Xr), "a digit"), d_ = /^\s$/, Us = function(e) {
  return d_.test(e);
}, Zs = R(j(Us), "a whitespace"), f_ = function(e) {
  return e === "_";
}, vt = function(e) {
  return /[a-z]/.test(e.toLowerCase());
}, Hs = function(e) {
  return vt(e) || Xr(e) || f_(e);
};
R(j(Hs), "a word character");
R(j(vt), "a letter");
var p_ = function(e) {
  return e.toLowerCase() !== e.toUpperCase();
};
R(j(p_), "an unicode letter");
var qs = function(e) {
  return vt(e) && e === e.toUpperCase();
};
R(j(qs), "an upper case letter");
var Bs = function(e) {
  return vt(e) && e === e.toLowerCase();
};
R(j(Bs), "a lower case letter");
R(j(ae(Xr)), "a non-digit");
var Gs = R(j(ae(Us)), "a non-whitespace character");
R(j(ae(Hs)), "a non-word character");
R(j(ae(vt)), "a non-letter character");
R(j(ae(qs)), "anything but an upper case letter");
R(j(ae(Bs)), "anything but a lower case letter");
var zs = function(e) {
  return R(o_.chainRec(e, function(t) {
    return y(m_(0, t), Br(function() {
      return $e(z(e));
    }, function(r) {
      return y(Ae(r), fe(function() {
        return $e(se(t.slice(1)));
      }));
    }));
  }), JSON.stringify(e));
}, Er = c_(i_(wr)), rt = Ns(wr), h_ = function(e) {
  return rt(v_(e));
}, v_ = function(e) {
  return y(Kr(e), k(function(t) {
    return t.join("");
  }));
}, m_ = function(e, t) {
  return e < t.length ? ut(t.charAt(e)) : rr;
}, g_ = Yr(Zs);
ht(Zs);
Yr(Gs);
ht(Gs);
var y_ = function(e) {
  var t = +e;
  return isNaN(t) || e === "" ? rr : ut(t);
};
R(y(Er([rt(Ae("-")), ht(Sr)]), k(function(e) {
  return +e;
})), "an integer");
R(y(Er([rt(Ae("-")), Yr(Sr), rt(Er([Ae("."), ht(Sr)]))]), fe(function(e) {
  return y(y_(e), Br(function() {
    return Ky();
  }, zr));
})), "a float");
var __ = Ps(Ae('"'))(h_(ar(zs('\\"'), function() {
  return l_('"');
})));
function Fs(e) {
  return function(t) {
    return t(By(e.split("")));
  };
}
const Kn = (e, t) => (r) => ({
  ...r,
  [e]: t(r[e])
}), b_ = ["#", ":"], Se = Ps(g_), en = (e) => (t) => t.join(e), tn = (e) => y(
  t_((t) => e.includes(t)),
  k(en(""))
), T_ = Y(
  tn,
  Jr(() => j(() => !0))
), Ks = y(
  __,
  k((e) => JSON.parse(`"${e}"`))
), $_ = y(
  Se(Ks),
  pe(
    () => y(
      tn([":", `
`]),
      k(ra)
    )
  )
), A_ = y(
  Se(Ks),
  pe(
    () => y(
      tn([`
`]),
      k(ra)
    )
  )
), Ws = y(
  rt(zs("#")),
  k(ae(na))
), Qs = y(
  Se(Ws),
  Ls("commented"),
  Ar("key", () => Se($_)),
  Jr(() => Ae(":")),
  Ar("value", () => A_)
), S_ = y(
  Se(Ws),
  Ls("commented"),
  Ar("key", () => ar(
    T_([`
`]),
    () => y(
      Wr(j((e) => !0), Fr()),
      k(Y(
        Cs,
        en("")
      ))
    )
  )),
  k(Y(
    Is(({ key: e }) => !na(e))
  ))
), E_ = y(
  Wr(Se(Qs), Fr())
), w_ = y(
  Wr(
    ar(
      y(Qs, k(ut)),
      () => y(
        S_,
        k(Y(
          $r((e) => ({ ...e, value: "" }))
        ))
      )
    ),
    Fr()
  ),
  k(Y(
    Sy(Y(
      Is(My),
      $r((e) => e.value)
    ))
  ))
), x_ = (e) => {
  if (b_.some((n) => e.includes(n)))
    return !0;
  const t = JSON.stringify(e);
  return t.substring(1, t.length - 1).trim() !== e;
}, Wn = (e) => x_(e) ? JSON.stringify(e) : e, F_ = (e) => y(
  e,
  Oy(
    Y(
      Kn("key", Wn),
      Kn("value", Wn),
      ({ key: t, value: r, active: n }) => n ? `${t}: ${r}` : `# ${t}: ${r}`
    )
  ),
  en(`
`)
), k_ = (e) => y(
  w_,
  Fs(e),
  nr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  lt(
    ({ value: t }) => y(
      t,
      Os(
        ({ key: r, value: n, commented: s }) => ({
          active: !s,
          key: r,
          value: n
        })
      )
    )
  )
), K_ = (e) => y(
  E_,
  Fs(e),
  nr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  lt(
    ({ value: t }) => y(
      t,
      Os(
        ({ key: r, value: n, commented: s }) => ({
          active: !s,
          key: r,
          value: n
        })
      )
    )
  )
), W_ = Y(
  k_,
  lt(Cs),
  Gr(() => [])
), R_ = a.object({
  id: a.optional(a.string()),
  name: a.string(),
  variables: a.array(
    a.object({
      key: a.string(),
      value: a.string()
    })
  )
}), Qn = E({
  initial: !0,
  schema: R_
}), Js = () => Math.random().toString(36).substring(2, 16), j_ = a.object({
  v: a.literal(1),
  id: a.string(),
  name: a.string(),
  variables: a.array(
    a.union([
      a.object({
        key: a.string(),
        secret: a.literal(!0)
      }),
      a.object({
        key: a.string(),
        value: a.string(),
        secret: a.literal(!1).catch(!1)
      })
    ])
  )
}), O_ = E({
  initial: !1,
  schema: j_,
  up(e) {
    return {
      ...e,
      v: 1,
      id: e.id || Js(),
      variables: e.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), Ys = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : r === 14 ? t += "4" : r === 19 ? t += e.charAt(8 + Math.floor(Math.random() * 4)) : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alpha-numeric character.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return e.charAt(Math.floor(Math.random() * e.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const e = ["red", "green", "blue", "yellow", "purple", "orange"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "#";
      for (let r = 0; r < 6; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const e = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16)
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16)
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alpha-numeric password.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let t = "";
      for (let r = 0; r < 15; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const e = ["ny", "sr", "si"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const e = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const e = ["http", "https"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${e[Math.floor(Math.random() * e.length)]} ${t[Math.floor(Math.random() * t.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const e = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const e = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const e = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const e = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const e = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const e = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const e = ["Supervisor", "Manager", "Coordinator", "Director"];
      return e[Math.floor(Math.random() * e.length)];
    }
  }
  // TODO: Support various other predefined variables
], C_ = a.object({
  v: a.number()
}), Q_ = st({
  latestVersion: 1,
  versionMap: {
    0: Qn,
    1: O_
  },
  getVersion(e) {
    const t = C_.safeParse(e);
    return t.success ? t.data.v : Qn.schema.safeParse(e).success ? 0 : null;
  }
}), Nt = /<<([^>]*)>>/g, Pt = 10, Xs = "ENV_EXPAND_LOOP", Jn = 1;
function I_(e, t) {
  let r = e, n = 0;
  for (; r.match(Nt) != null && n <= Pt; )
    r = r.replace(Nt, (s) => {
      const i = s.replace(/[<>]/g, ""), o = Ys.find(
        (u) => u.key === i
      );
      if (o)
        return o.getValue();
      const c = t.find((u) => u.key === i);
      return c && "value" in c ? c.value : s;
    }), n++;
  return n > Pt ? se(Xs) : z(r);
}
const J_ = (e, t) => y(
  I_(e, t),
  Gr(() => e)
);
function M_(e, t, r = !1, n = !1) {
  if (!t || !e)
    return z(e);
  let s = e, i = 0, o = !1;
  for (; s.match(Nt) != null && i <= Pt && !o; )
    s = decodeURI(encodeURI(s)).replace(Nt, (c, u) => {
      const l = Ys.find(
        (_) => _.key === u
      );
      if (l)
        return l.getValue();
      const f = t.find((_) => _ && _.key === u);
      return f && "value" in f ? f.secret && n ? (o = !0, `<<${u}>>`) : f.secret && r ? "*".repeat(
        f.value.length
      ) : f.value : "";
    }), i++;
  return i > Pt ? se(Xs) : z(s);
}
const Y_ = (e, t, r = !1, n = !1) => y(
  M_(e, t, r, n),
  Gr(() => e)
), N_ = (e) => ({
  key: e.key,
  value: e.value,
  secret: !1
}), X_ = (e) => {
  if (e.v && e.v === Jn) return e;
  const t = e.id || Js(), r = e.name ?? "Untitled", n = (e.variables ?? []).map(N_);
  return {
    v: Jn,
    id: t,
    name: r,
    variables: n
  };
}, P_ = a.array(
  a.union([
    a.object({
      key: a.string(),
      value: a.string(),
      secret: a.literal(!1)
    }),
    a.object({
      key: a.string(),
      secret: a.literal(!0)
    }),
    a.object({
      key: a.string(),
      value: a.string()
    })
  ])
), Yn = E({
  initial: !0,
  schema: P_
}), V_ = a.object({
  v: a.literal(1),
  variables: a.array(
    a.union([
      a.object({
        key: a.string(),
        secret: a.literal(!0)
      }),
      a.object({
        key: a.string(),
        value: a.string(),
        secret: a.literal(!1)
      })
    ])
  )
}), D_ = E({
  initial: !1,
  schema: V_,
  up(e) {
    return {
      v: 1,
      variables: e.map((r) => "value" in r ? {
        key: r.key,
        value: r.value,
        secret: !1
      } : {
        key: r.key,
        secret: !0
      })
    };
  }
}), L_ = a.object({
  v: a.number()
}), eb = st({
  latestVersion: 1,
  versionMap: {
    0: Yn,
    1: D_
  },
  getVersion(e) {
    const t = L_.safeParse(e);
    return t.success ? t.data.v : Yn.schema.safeParse(e).success ? 0 : null;
  }
});
export {
  Wa as AuthCodeGrantTypeParams,
  Eg as ClientCredentialsGrantTypeParams,
  yy as CollectionSchemaVersion,
  Q_ as Environment,
  Jn as EnvironmentSchemaVersion,
  Ig as FormDataKeyValue,
  vs as GQLHeader,
  _s as GQL_REQ_SCHEMA_VERSION,
  eb as GlobalEnvironment,
  Ys as HOPP_SUPPORTED_PREDEFINED_VARIABLES,
  z_ as HoppCollection,
  ys as HoppGQLAuth,
  tr as HoppGQLAuthAPIKey,
  hs as HoppGQLAuthAWSSignature,
  Pe as HoppGQLAuthBasic,
  Ve as HoppGQLAuthBearer,
  De as HoppGQLAuthInherit,
  Ne as HoppGQLAuthNone,
  ts as HoppGQLAuthOAuth2,
  qr as HoppGQLRequest,
  ct as HoppRESTAuth,
  Fa as HoppRESTAuthAPIKey,
  Lr as HoppRESTAuthAWSSignature,
  Ce as HoppRESTAuthBasic,
  Ie as HoppRESTAuthBearer,
  kg as HoppRESTAuthDigest,
  Me as HoppRESTAuthInherit,
  Oe as HoppRESTAuthNone,
  xg as HoppRESTAuthOAuth2,
  ot as HoppRESTHeaders,
  Xt as HoppRESTParams,
  Ur as HoppRESTReqBody,
  er as HoppRESTRequest,
  Ng as HoppRESTRequestResponse,
  os as HoppRESTRequestResponses,
  Ft as HoppRESTRequestVariables,
  Mg as HoppRESTResponseOriginalRequest,
  Qt as ImplicitOauthFlowParams,
  wg as PasswordGrantTypeParams,
  cs as RESTReqSchemaVersion,
  U_ as ValidContentTypesList,
  xs as generateUniqueRefId,
  ay as getDefaultGQLRequest,
  Zg as getDefaultRESTRequest,
  Z_ as isEqualHoppRESTRequest,
  B_ as isHoppRESTRequest,
  Dg as knownContentTypes,
  Rs as makeCollection,
  G_ as makeGQLRequest,
  q_ as makeRESTRequest,
  J_ as parseBodyEnvVariables,
  I_ as parseBodyEnvVariablesE,
  W_ as parseRawKeyValueEntries,
  k_ as parseRawKeyValueEntriesE,
  Y_ as parseTemplateString,
  M_ as parseTemplateStringE,
  F_ as rawKeyValueEntriesToString,
  H_ as safelyExtractRESTRequest,
  K_ as strictParseRawKeyValueEntriesE,
  sy as translateToGQLRequest,
  X_ as translateToNewEnvironment,
  N_ as translateToNewEnvironmentVariables,
  by as translateToNewGQLCollection,
  _y as translateToNewRESTCollection,
  Hg as translateToNewRequest
};
